// // // // // // // import React, { useEffect, useState } from "react";
// // // // // // // import { useNavigate } from "react-router-dom";
// // // // // // // import { db } from "../firebase";
// // // // // // // import { ref as dbRef, onValue } from "firebase/database";
// // // // // // // import "./OfferSection.css";

// // // // // // // export default function OfferSection() {
// // // // // // //   const navigate = useNavigate();
// // // // // // //   const [categories, setCategories] = useState([]);

// // // // // // //   /* ================= FETCH CATEGORIES FROM FIREBASE ================= */
// // // // // // //   useEffect(() => {
// // // // // // //     const categoriesRef = dbRef(db, "categories");

// // // // // // //     const unsubscribe = onValue(categoriesRef, (snapshot) => {
// // // // // // //       const data = snapshot.val();
// // // // // // //       if (!data) {
// // // // // // //         setCategories([]);
// // // // // // //         return;
// // // // // // //       }

// // // // // // //       const parsed = Object.keys(data).map((id) => ({
// // // // // // //         id,
// // // // // // //         ...data[id],
// // // // // // //         subcategories: data[id].subcategories
// // // // // // //           ? Object.keys(data[id].subcategories).map((sid) => ({
// // // // // // //               id: sid,
// // // // // // //               ...data[id].subcategories[sid],
// // // // // // //             }))
// // // // // // //           : [],
// // // // // // //       }));

// // // // // // //       setCategories(parsed);
// // // // // // //     });

// // // // // // //     return () => unsubscribe();
// // // // // // //   }, []);

// // // // // // //   /* ================= NAVIGATION HANDLER ================= */
// // // // // // //   const handleNavigate = (category) => {
// // // // // // //     navigate("/sub-category", {
// // // // // // //       state: {
// // // // // // //         categoryId: category.id,
// // // // // // //         categoryTitle: category.title,
// // // // // // //         categoryDescription: category.description,
// // // // // // //         subcategories: category.subcategories,
// // // // // // //       },
// // // // // // //     });
// // // // // // //   };

// // // // // // //   return (
// // // // // // //     <section id="offer" className="hlc-offer" aria-label="HLC Product Categories">
// // // // // // //       <div className="hlc-offer__inner">
// // // // // // //         {/* ===== HEADER ===== */}
// // // // // // //         <header className="hlc-offer__head">
// // // // // // //           <p className="hlc-offer__eyebrow">Product Families</p>
// // // // // // //           <h2 className="hlc-offer__title">Lighting Solutions by Category</h2>
// // // // // // //           <p className="hlc-offer__sub">
// // // // // // //             HLC LEDs for every application – from bulbs and downlights to batten,
// // // // // // //             panel, flood and decorative lighting.
// // // // // // //           </p>
// // // // // // //         </header>

// // // // // // //         {/* ===== CATEGORY GRID ===== */}
// // // // // // //         <div className="hlc-offer__row">
// // // // // // //           {categories.map((cat) => (
// // // // // // //             <div
// // // // // // //               key={cat.id}
// // // // // // //               className="offer-card"
// // // // // // //               role="button"
// // // // // // //               tabIndex={0}
// // // // // // //               onClick={() => handleNavigate(cat)}
// // // // // // //               onKeyDown={(e) => e.key === "Enter" && handleNavigate(cat)}
// // // // // // //             >
// // // // // // //               <div className="offer-card__imgwrap">
// // // // // // //                 <img
// // // // // // //                   src={cat.image || "https://via.placeholder.com/600x400"}
// // // // // // //                   alt={cat.title}
// // // // // // //                   loading="lazy"
// // // // // // //                 />
// // // // // // //               </div>

// // // // // // //               <div className="offer-card__body">
// // // // // // //                 <h3 className="offer-card__title">{cat.title}</h3>
// // // // // // //                 <p className="offer-card__text">
// // // // // // //                   {cat.description || "Explore our complete range of products."}
// // // // // // //                 </p>
// // // // // // //                 <span className="offer-card__cta">
// // // // // // //                   {cat.buttonText || "View Products →"}
// // // // // // //                 </span>
// // // // // // //               </div>
// // // // // // //             </div>
// // // // // // //           ))}
// // // // // // //         </div>
// // // // // // //       </div>
// // // // // // //     </section>
// // // // // // //   );
// // // // // // // }

// // // // // // // import React from "react";
// // // // // // // import { useNavigate } from "react-router-dom";
// // // // // // // import LedBulbImg from "../assets/products/3.png";
// // // // // // // import DownlightImg from "../assets/products/9.png";
// // // // // // // import PanelImg from "../assets/products/28.png";
// // // // // // // import FloodImg from "../assets/products/31.png";
// // // // // // // import RopeImg from "../assets/products/35.png";

// // // // // // // /* ================= STATIC LOCAL CATEGORIES ================= */
// // // // // // // // `dbCategory` must match the real `products.category` value in MySQL exactly
// // // // // // // // (case + wording) -- it's what gets sent to /product-by-categories for
// // // // // // // // filtering. `title` stays the nicer display text shown on the card itself.
// // // // // // // const CATEGORIES = [
// // // // // // //   {
// // // // // // //     id: "led-bulbs",
// // // // // // //     title: "LED Bulb Series",
// // // // // // //     dbCategory: "LED BULB SERIES",
// // // // // // //     description: "Candle, A-Series & T-Series bulbs for homes, shops and offices.",
// // // // // // //     image: LedBulbImg,
// // // // // // //     subcategories: [],
// // // // // // //   },
// // // // // // //   {
// // // // // // //     id: "downlights",
// // // // // // //     title: "Downlights & COB",
// // // // // // //     dbCategory: "DOWNLIGHT SERIES",
// // // // // // //     description: "COB, SMD & surface downlights for modern ceilings.",
// // // // // // //     image: DownlightImg,
// // // // // // //     subcategories: [],
// // // // // // //   },
// // // // // // //   {
// // // // // // //     id: "batten-tube",
// // // // // // //     title: "Batten & LED Tube Series",
// // // // // // //     dbCategory: "BATTEN AND LED TUBE SERIES",
// // // // // // //     description: "Batten lights and LED tube rods for uniform, energy-efficient lighting.",
// // // // // // //     image: DownlightImg,
// // // // // // //     subcategories: [],
// // // // // // //   },
// // // // // // //   {
// // // // // // //     id: "panel-lights",
// // // // // // //     title: "Panel & Ceiling Lights",
// // // // // // //     dbCategory: "PANEL LIGHT SERIES",
// // // // // // //     description: "Recessed & surface panels for offices and retail spaces.",
// // // // // // //     image: PanelImg,
// // // // // // //     subcategories: [],
// // // // // // //   },
// // // // // // //   {
// // // // // // //     id: "flood-outdoor",
// // // // // // //     title: "Flood & Outdoor",
// // // // // // //     dbCategory: "STREET AND FLOOD LIGHT SERIES",
// // // // // // //     description: "IP-rated flood, street & area lighting for outdoor projects.",
// // // // // // //     image: FloodImg,
// // // // // // //     subcategories: [],
// // // // // // //   },
// // // // // // //   {
// // // // // // //     id: "rope-decorative",
// // // // // // //     title: "Rope & Decorative",
// // // // // // //     dbCategory: "ROPE LIGHT SERIES",
// // // // // // //     description: "Rope lights, strips and accent profiles for creative lighting.",
// // // // // // //     image: RopeImg,
// // // // // // //     subcategories: [],
// // // // // // //   },
// // // // // // // ];

// // // // // // // const ProductCategories = () => {
// // // // // // //   const navigate = useNavigate();
// // // // // // //   const categories = CATEGORIES;

// // // // // // //   /* ================= NAVIGATION HANDLER ================= */
// // // // // // //   // const handleNavigate = (category) => {
// // // // // // //   //   navigate("/sub-category", {
// // // // // // //   //     state: {
// // // // // // //   //       categoryId: category.id,
// // // // // // //   //       categoryTitle: category.title,
// // // // // // //   //       categoryDescription: category.description,
// // // // // // //   //       subcategories: category.subcategories,
// // // // // // //   //     },
// // // // // // //   //   });
// // // // // // //   // };
// // // // // // //   const handleNavigate = (category) => {
// // // // // // //   navigate("/product-by-categories", {
// // // // // // //     state: {
// // // // // // //       category: category.dbCategory,
// // // // // // //       // OPTIONAL: if you want all subcategories available for filters
// // // // // // //       subcategories: category.subcategories || [],
// // // // // // //     },
// // // // // // //   });
// // // // // // // };
// // // // // // //   return (
// // // // // // //     <>
// // // // // // //       <style>{`
// // // // // // //         :root{
// // // // // // //           --hlc-magenta:#9b1f6c;
// // // // // // //           --hlc-plum:#542757;
// // // // // // //           --hlc-navy:#35335b;
// // // // // // //           --hlc-line:#eceaf1;
// // // // // // //         }

// // // // // // //         #offer.hlc-offer{
// // // // // // //           width:100%;
// // // // // // //           padding:clamp(32px,6vw,48px) 0;
// // // // // // //           background:linear-gradient(180deg,#f7f7fb 0%,#ffffff 100%);
// // // // // // //           font-family:"Open Sans",system-ui,-apple-system,Segoe UI,Roboto,Arial,sans-serif;
// // // // // // //           color:#141320;
// // // // // // //         }

// // // // // // //         .hlc-offer__inner{
// // // // // // //           width:min(1200px,92vw);
// // // // // // //           margin:0 auto;
// // // // // // //         }

// // // // // // //         .hlc-offer__head{
// // // // // // //           text-align:center;
// // // // // // //           margin-bottom:clamp(20px,3vw,28px);
// // // // // // //         }

// // // // // // //         .hlc-offer__eyebrow{
// // // // // // //           margin:0 0 4px;
// // // // // // //           font-size:11px;
// // // // // // //           letter-spacing:.18em;
// // // // // // //           text-transform:uppercase;
// // // // // // //           color:#6f6d83;
// // // // // // //         }

// // // // // // //         .hlc-offer__title{
// // // // // // //           margin:0 0 6px;
// // // // // // //           font-size:clamp(22px,3vw,30px);
// // // // // // //           font-weight:800;
// // // // // // //           letter-spacing:-.02em;
// // // // // // //           color:var(--hlc-navy);
// // // // // // //         }

// // // // // // //         .hlc-offer__sub{
// // // // // // //           margin:0 auto;
// // // // // // //           max-width:620px;
// // // // // // //           font-size:14px;
// // // // // // //           color:#4d4b60;
// // // // // // //         }

// // // // // // //         .hlc-offer__row{
// // // // // // //           margin-top:clamp(18px,3vw,26px);
// // // // // // //           display:grid;
// // // // // // //           grid-template-columns:repeat(3,minmax(0,1fr));
// // // // // // //           gap:18px;
// // // // // // //         }

// // // // // // //         .offer-card{
// // // // // // //           display:flex;
// // // // // // //           flex-direction:column;
// // // // // // //           text-decoration:none;
// // // // // // //           background:#fff;
// // // // // // //           border:1px solid var(--hlc-line);
// // // // // // //           box-shadow:0 10px 24px rgba(20,19,32,.06);
// // // // // // //           overflow:hidden;
// // // // // // //           color:#141320;
// // // // // // //           transition:all .3s ease;
// // // // // // //           cursor:pointer;
// // // // // // //         }

// // // // // // //         .offer-card__imgwrap{
// // // // // // //           position:relative;
// // // // // // //           aspect-ratio:4/3;
// // // // // // //           overflow:hidden;
// // // // // // //           background:#f4f4f8;
// // // // // // //         }

// // // // // // //         .offer-card__imgwrap img{
// // // // // // //           width:100%;
// // // // // // //           height:100%;
// // // // // // //           object-fit:cover;
// // // // // // //           display:block;
// // // // // // //           transition:transform .4s ease;
// // // // // // //         }

// // // // // // //         .offer-card__body{
// // // // // // //           padding:12px 14px 14px;
// // // // // // //         }

// // // // // // //         .offer-card__title{
// // // // // // //           margin:0 0 4px;
// // // // // // //           font-size:15px;
// // // // // // //           font-weight:700;
// // // // // // //           color:var(--hlc-navy);
// // // // // // //         }

// // // // // // //         .offer-card__text{
// // // // // // //           margin:0 0 8px;
// // // // // // //           font-size:13px;
// // // // // // //           line-height:1.5;
// // // // // // //           color:#55536a;
// // // // // // //         }

// // // // // // //         .offer-card__cta{
// // // // // // //           display:inline-block;
// // // // // // //           margin-top:2px;
// // // // // // //           font-size:12px;
// // // // // // //           font-weight:700;
// // // // // // //           text-transform:uppercase;
// // // // // // //           letter-spacing:.12em;
// // // // // // //           color:var(--hlc-magenta);
// // // // // // //         }

// // // // // // //         .offer-card:hover img{
// // // // // // //           transform:scale(1.06);
// // // // // // //         }

// // // // // // //         .offer-card:hover{
// // // // // // //           border-color:rgba(155,31,108,.4);
// // // // // // //           box-shadow:0 18px 40px rgba(155,31,108,.20);
// // // // // // //         }

// // // // // // //         .offer-card:hover .offer-card__cta{
// // // // // // //           color:var(--hlc-plum);
// // // // // // //         }

// // // // // // //         .offer-card__placeholder{
// // // // // // //           width:100%;
// // // // // // //           height:100%;
// // // // // // //           display:flex;
// // // // // // //           align-items:center;
// // // // // // //           justify-content:center;
// // // // // // //           color:#999;
// // // // // // //           font-size:14px;
// // // // // // //           background:linear-gradient(135deg,#f5f5f8,#ececf3);
// // // // // // //         }

// // // // // // //         .hlc-offer__empty{
// // // // // // //           text-align:center;
// // // // // // //           padding:40px 20px;
// // // // // // //           color:#666;
// // // // // // //           font-size:15px;
// // // // // // //         }

// // // // // // //         /* tablet */
// // // // // // //         @media (max-width: 991px){
// // // // // // //           .hlc-offer__row{
// // // // // // //             grid-template-columns:repeat(3,minmax(0,1fr));
// // // // // // //             gap:14px;
// // // // // // //           }
// // // // // // //         }

// // // // // // //         /* mobile */
// // // // // // //         @media (max-width: 767px){
// // // // // // //           .hlc-offer__row{
// // // // // // //             grid-template-columns:repeat(2,minmax(0,1fr)) !important;
// // // // // // //             gap:12px !important;
// // // // // // //           }

// // // // // // //           .offer-card{
// // // // // // //             min-width:0;
// // // // // // //           }

// // // // // // //           .offer-card__body{
// // // // // // //             padding:10px;
// // // // // // //           }

// // // // // // //           .offer-card__title{
// // // // // // //             font-size:13px;
// // // // // // //             line-height:1.35;
// // // // // // //           }

// // // // // // //           .offer-card__text{
// // // // // // //             font-size:11px;
// // // // // // //             line-height:1.45;
// // // // // // //             margin-bottom:6px;
// // // // // // //           }

// // // // // // //           .offer-card__cta{
// // // // // // //             font-size:10px;
// // // // // // //             letter-spacing:.06em;
// // // // // // //           }
// // // // // // //         }
// // // // // // //       `}</style>

// // // // // // //       <section
// // // // // // //         id="offer"
// // // // // // //         className="hlc-offer"
// // // // // // //         aria-label="HLC Product Categories"
// // // // // // //       >
// // // // // // //         <div className="hlc-offer__inner">
// // // // // // //           <header className="hlc-offer__head">
// // // // // // //             <p className="hlc-offer__eyebrow">Product Families</p>
// // // // // // //             <h2 className="hlc-offer__title">Lighting Solutions by Category</h2>
// // // // // // //             <p className="hlc-offer__sub">
// // // // // // //               HLC LEDs for every application – from bulbs, downlights, batten,
// // // // // // //               panel, flood and decorative lighting.
// // // // // // //             </p>
// // // // // // //           </header>

// // // // // // //           {categories.length === 0 ? (
// // // // // // //             <div className="hlc-offer__empty">
// // // // // // //               No categories found.
// // // // // // //             </div>
// // // // // // //           ) : (
// // // // // // //             <div className="hlc-offer__row">
// // // // // // //               {categories.map((category) => (
// // // // // // //                 <div
// // // // // // //                   key={category.id}
// // // // // // //                   className="offer-card"
// // // // // // //                   onClick={() => handleNavigate(category)}
// // // // // // //                 >
// // // // // // //                   <div className="offer-card__imgwrap">
// // // // // // //                     {category.image ? (
// // // // // // //                       <img
// // // // // // //                         src={category.image}
// // // // // // //                         alt={category.title || "Category"}
// // // // // // //                       />
// // // // // // //                     ) : (
// // // // // // //                       <div className="offer-card__placeholder">
// // // // // // //                         No Image
// // // // // // //                       </div>
// // // // // // //                     )}
// // // // // // //                   </div>

// // // // // // //                   <div className="offer-card__body">
// // // // // // //                     <h3 className="offer-card__title">
// // // // // // //                       {category.title || "Untitled Category"}
// // // // // // //                     </h3>

// // // // // // //                     <p className="offer-card__text">
// // // // // // //                       {category.description ||
// // // // // // //                         "Explore premium HLC lighting solutions for this category."}
// // // // // // //                     </p>

// // // // // // //                     <span className="offer-card__cta">
// // // // // // //                       View Category →
// // // // // // //                     </span>
// // // // // // //                   </div>
// // // // // // //                 </div>
// // // // // // //               ))}
// // // // // // //             </div>
// // // // // // //           )}
// // // // // // //         </div>
// // // // // // //       </section>
// // // // // // //     </>
// // // // // // //   );
// // // // // // // };

// // // // // // // export default ProductCategories;


// // // // // // import React from "react";
// // // // // // import { useNavigate } from "react-router-dom";
// // // // // // import { motion } from "framer-motion";
// // // // // // import LedBulbImg from "../assets/products/3.png";
// // // // // // import DownlightImg from "../assets/products/9.png";
// // // // // // import PanelImg from "../assets/products/28.png";
// // // // // // import FloodImg from "../assets/products/31.png";
// // // // // // import RopeImg from "../assets/products/35.png";

// // // // // // /* ---------- small line icons, one per family ---------- */
// // // // // // const Icon = ({ name }) => {
// // // // // //   const common = {
// // // // // //     width: 17,
// // // // // //     height: 17,
// // // // // //     viewBox: "0 0 24 24",
// // // // // //     fill: "none",
// // // // // //     stroke: "currentColor",
// // // // // //     strokeWidth: 1.8,
// // // // // //     strokeLinecap: "round",
// // // // // //     strokeLinejoin: "round",
// // // // // //     "aria-hidden": "true",
// // // // // //   };
// // // // // //   switch (name) {
// // // // // //     case "bulb":
// // // // // //       return (
// // // // // //         <svg {...common}>
// // // // // //           <path d="M9 18h6M10 21h4M12 3a6 6 0 0 0-3.5 10.9c.5.4.8 1 .8 1.6V16h5.4v-.5c0-.6.3-1.2.8-1.6A6 6 0 0 0 12 3Z" />
// // // // // //         </svg>
// // // // // //       );
// // // // // //     case "downlight":
// // // // // //       return (
// // // // // //         <svg {...common}>
// // // // // //           <circle cx="12" cy="9" r="5" />
// // // // // //           <path d="M6 20h12M8.5 16.5 7 20M15.5 16.5 17 20" />
// // // // // //         </svg>
// // // // // //       );
// // // // // //     case "tube":
// // // // // //       return (
// // // // // //         <svg {...common}>
// // // // // //           <rect x="3" y="9" width="18" height="6" rx="3" />
// // // // // //           <path d="M7 12h10" />
// // // // // //         </svg>
// // // // // //       );
// // // // // //     case "panel":
// // // // // //       return (
// // // // // //         <svg {...common}>
// // // // // //           <rect x="4" y="4" width="16" height="16" rx="2" />
// // // // // //           <path d="M9 9h6v6H9z" />
// // // // // //         </svg>
// // // // // //       );
// // // // // //     case "flood":
// // // // // //       return (
// // // // // //         <svg {...common}>
// // // // // //           <rect x="4" y="5" width="12" height="9" rx="1.5" />
// // // // // //           <path d="M16 8.5h4M10 14v5M7 19h6" />
// // // // // //         </svg>
// // // // // //       );
// // // // // //     default:
// // // // // //       return (
// // // // // //         <svg {...common}>
// // // // // //           <circle cx="7" cy="9" r="2" />
// // // // // //           <circle cx="14" cy="15" r="2" />
// // // // // //           <circle cx="18" cy="7" r="2" />
// // // // // //         </svg>
// // // // // //       );
// // // // // //   }
// // // // // // };

// // // // // // /* ================= STATIC LOCAL CATEGORIES =================
// // // // // //    `dbCategory` must match the real `products.category` value in MySQL exactly. */
// // // // // // const CATEGORIES = [
// // // // // //   {
// // // // // //     id: "led-bulbs",
// // // // // //     title: "LED Bulb Series",
// // // // // //     dbCategory: "LED BULB SERIES",
// // // // // //     description: "Reliable, efficient bulbs for every home and office.",
// // // // // //     image: LedBulbImg,
// // // // // //     icon: "bulb",
// // // // // //     subcategories: [],
// // // // // //   },
// // // // // //   {
// // // // // //     id: "downlights",
// // // // // //     title: "Downlights & COB",
// // // // // //     dbCategory: "DOWNLIGHT SERIES",
// // // // // //     description: "Sleek COB and SMD downlights for modern interiors.",
// // // // // //     image: DownlightImg,
// // // // // //     icon: "downlight",
// // // // // //     subcategories: [],
// // // // // //   },
// // // // // //   {
// // // // // //     id: "batten-tube",
// // // // // //     title: "Batten & Tube Series",
// // // // // //     dbCategory: "BATTEN AND LED TUBE SERIES",
// // // // // //     description: "Durable, bright tube lights and battens for all spaces.",
// // // // // //     // TODO: swap in a real batten/tube PNG — this reuses the downlight photo.
// // // // // //     image: DownlightImg,
// // // // // //     icon: "tube",
// // // // // //     subcategories: [],
// // // // // //   },
// // // // // //   {
// // // // // //     id: "panel-lights",
// // // // // //     title: "Panel & Ceiling Lights",
// // // // // //     dbCategory: "PANEL LIGHT SERIES",
// // // // // //     description: "Modern panels for a clean, even ceiling finish.",
// // // // // //     image: PanelImg,
// // // // // //     icon: "panel",
// // // // // //     subcategories: [],
// // // // // //   },
// // // // // //   {
// // // // // //     id: "flood-outdoor",
// // // // // //     title: "Flood & Outdoor",
// // // // // //     dbCategory: "STREET AND FLOOD LIGHT SERIES",
// // // // // //     description: "High-output flood and street lighting built for weather.",
// // // // // //     image: FloodImg,
// // // // // //     icon: "flood",
// // // // // //     subcategories: [],
// // // // // //   },
// // // // // //   {
// // // // // //     id: "rope-decorative",
// // // // // //     title: "Rope & Decorative",
// // // // // //     dbCategory: "ROPE LIGHT SERIES",
// // // // // //     description: "Rope and strip lighting for accent and ambience.",
// // // // // //     image: RopeImg,
// // // // // //     icon: "rope",
// // // // // //     subcategories: [],
// // // // // //   },
// // // // // // ];

// // // // // // const cardMotion = {
// // // // // //   hidden: { opacity: 0, y: 14 },
// // // // // //   show: (i) => ({
// // // // // //     opacity: 1,
// // // // // //     y: 0,
// // // // // //     transition: { duration: 0.5, delay: i * 0.06, ease: [0.16, 1, 0.3, 1] },
// // // // // //   }),
// // // // // // };

// // // // // // const OfferSection = () => {
// // // // // //   const navigate = useNavigate();

// // // // // //   const handleNavigate = (category) => {
// // // // // //     navigate("/product-by-categories", {
// // // // // //       state: {
// // // // // //         category: category.dbCategory,
// // // // // //         subcategories: category.subcategories || [],
// // // // // //       },
// // // // // //     });
// // // // // //   };

// // // // // //   return (
// // // // // //     <>
// // // // // //       <style>{`
// // // // // //         #offer.hlc-offer{
// // // // // //           --magenta:#9b1f6c;
// // // // // //           --plum:#542757;
// // // // // //           --navy:#35335b;
// // // // // //           --ink:#191825;
// // // // // //           --muted:#6b6880;
// // // // // //           --lilac:#f0e8f8;
// // // // // //           --plate:#f4f3f7;
// // // // // //           --plate-lit:#fdf6f9;
// // // // // //           --ease:cubic-bezier(.16,1,.3,1);

// // // // // //           position:relative;
// // // // // //           width:100%;
// // // // // //           padding:clamp(44px,6vw,76px) 0 clamp(48px,6.5vw,84px);
// // // // // //           background:linear-gradient(178deg,#f5eefb 0%,#faf8fd 42%,#fdfcfe 100%);
// // // // // //           font-family:"Manrope","Inter",system-ui,-apple-system,Segoe UI,Roboto,Arial,sans-serif;
// // // // // //           color:var(--ink);
// // // // // //           overflow:hidden;
// // // // // //           isolation:isolate;
// // // // // //         }

// // // // // //         #offer.hlc-offer::before{
// // // // // //           content:"";
// // // // // //           position:absolute;
// // // // // //           top:-16%;
// // // // // //           right:-6%;
// // // // // //           width:min(660px,68vw);
// // // // // //           aspect-ratio:1;
// // // // // //           border-radius:50%;
// // // // // //           background:radial-gradient(circle,
// // // // // //                      rgba(255,255,255,.9) 0%,
// // // // // //                      rgba(228,209,244,.5) 38%,
// // // // // //                      rgba(228,209,244,0) 70%);
// // // // // //           z-index:-1;
// // // // // //           pointer-events:none;
// // // // // //         }

// // // // // //         .hlc-offer__lamps{
// // // // // //           position:absolute;
// // // // // //           top:0;
// // // // // //           right:clamp(-30px,2vw,50px);
// // // // // //           width:min(360px,40vw);
// // // // // //           z-index:-1;
// // // // // //           pointer-events:none;
// // // // // //         }

// // // // // //         .hlc-offer__inner{
// // // // // //           position:relative;
// // // // // //           width:min(1200px,90vw);
// // // // // //           margin:0 auto;
// // // // // //         }

// // // // // //         /* ---------- header ---------- */
// // // // // //         .hlc-offer__head{
// // // // // //           max-width:500px;
// // // // // //           margin:0 0 clamp(26px,3.4vw,40px);
// // // // // //         }
// // // // // //         .hlc-offer__eyebrow{
// // // // // //           margin:0 0 12px;
// // // // // //           font-size:11px;
// // // // // //           font-weight:800;
// // // // // //           letter-spacing:.22em;
// // // // // //           text-transform:uppercase;
// // // // // //           color:var(--magenta);
// // // // // //         }
// // // // // //         .hlc-offer__title{
// // // // // //           margin:0 0 12px;
// // // // // //           font-size:clamp(27px,3.6vw,40px);
// // // // // //           font-weight:800;
// // // // // //           line-height:1.12;
// // // // // //           letter-spacing:-.03em;
// // // // // //           color:var(--ink);
// // // // // //         }
// // // // // //         .hlc-offer__title em{ font-style:normal; color:var(--magenta); }
// // // // // //         .hlc-offer__sub{
// // // // // //           margin:0;
// // // // // //           max-width:400px;
// // // // // //           font-size:14.5px;
// // // // // //           line-height:1.65;
// // // // // //           color:var(--muted);
// // // // // //         }

// // // // // //         /* ---------- grid ---------- */
// // // // // //         .hlc-offer__row{
// // // // // //           display:grid;
// // // // // //           grid-template-columns:repeat(3,minmax(0,1fr));
// // // // // //           gap:clamp(14px,1.6vw,20px);
// // // // // //         }

// // // // // //         /* ---------- card ---------- */
// // // // // //         .offer-card{
// // // // // //           -webkit-appearance:none;
// // // // // //           appearance:none;
// // // // // //           border:0;
// // // // // //           margin:0;
// // // // // //           font:inherit;
// // // // // //           color:inherit;
// // // // // //           text-align:left;
// // // // // //           cursor:pointer;

// // // // // //           display:grid;
// // // // // //           grid-template-columns:minmax(0,1fr) 106px;
// // // // // //           align-items:center;
// // // // // //           gap:16px;
// // // // // //           padding:18px;
// // // // // //           border-radius:16px;
// // // // // //           background:#fff;
// // // // // //           box-shadow:0 1px 2px rgba(25,24,37,.04), 0 10px 26px rgba(84,39,87,.06);
// // // // // //           transition:transform .4s var(--ease), box-shadow .4s var(--ease);
// // // // // //         }
// // // // // //         .offer-card:hover{
// // // // // //           transform:translateY(-4px);
// // // // // //           box-shadow:0 1px 2px rgba(25,24,37,.04), 0 20px 40px rgba(155,31,108,.14);
// // // // // //         }
// // // // // //         .offer-card:focus-visible{
// // // // // //           outline:2px solid var(--magenta);
// // // // // //           outline-offset:3px;
// // // // // //         }

// // // // // //         .offer-card__icon{
// // // // // //           display:grid;
// // // // // //           place-items:center;
// // // // // //           width:32px;
// // // // // //           height:32px;
// // // // // //           margin-bottom:11px;
// // // // // //           border-radius:50%;
// // // // // //           background:var(--lilac);
// // // // // //           color:var(--plum);
// // // // // //           transition:background .4s var(--ease), color .4s var(--ease);
// // // // // //         }
// // // // // //         .offer-card:hover .offer-card__icon{
// // // // // //           background:var(--magenta);
// // // // // //           color:#fff;
// // // // // //         }

// // // // // //         .offer-card__title{
// // // // // //           margin:0 0 5px;
// // // // // //           font-size:15.5px;
// // // // // //           font-weight:800;
// // // // // //           line-height:1.3;
// // // // // //           letter-spacing:-.01em;
// // // // // //           color:var(--navy);
// // // // // //         }
// // // // // //         .offer-card__text{
// // // // // //           margin:0 0 12px;
// // // // // //           font-size:12.5px;
// // // // // //           line-height:1.55;
// // // // // //           color:var(--muted);
// // // // // //           display:-webkit-box;
// // // // // //           -webkit-line-clamp:2;
// // // // // //           -webkit-box-orient:vertical;
// // // // // //           overflow:hidden;
// // // // // //         }
// // // // // //         .offer-card__cta{
// // // // // //           display:inline-flex;
// // // // // //           align-items:center;
// // // // // //           gap:7px;
// // // // // //           font-size:10.5px;
// // // // // //           font-weight:800;
// // // // // //           letter-spacing:.15em;
// // // // // //           text-transform:uppercase;
// // // // // //           color:var(--magenta);
// // // // // //         }
// // // // // //         .offer-card__cta i{
// // // // // //           font-style:normal;
// // // // // //           transition:transform .4s var(--ease);
// // // // // //         }
// // // // // //         .offer-card:hover .offer-card__cta i{ transform:translateX(4px); }

// // // // // //         /* product plate — the grey photo backdrop reads as a designed panel */
// // // // // //         .offer-card__plate{
// // // // // //           position:relative;
// // // // // //           width:106px;
// // // // // //           height:106px;
// // // // // //           border-radius:12px;
// // // // // //           background:var(--plate);
// // // // // //           overflow:hidden;
// // // // // //           transition:background .45s var(--ease);
// // // // // //         }
// // // // // //         .offer-card:hover .offer-card__plate{ background:var(--plate-lit); }

// // // // // //         .offer-card__plate img{
// // // // // //           position:absolute;
// // // // // //           inset:0;
// // // // // //           width:100%;
// // // // // //           height:100%;
// // // // // //           object-fit:contain;
// // // // // //           padding:9px;
// // // // // //           box-sizing:border-box;
// // // // // //           mix-blend-mode:multiply;
// // // // // //           transition:transform .45s var(--ease);
// // // // // //         }
// // // // // //         .offer-card:hover .offer-card__plate img{ transform:scale(1.05); }

// // // // // //         .hlc-offer__empty{
// // // // // //           padding:40px 0;
// // // // // //           font-size:15px;
// // // // // //           color:var(--muted);
// // // // // //         }

// // // // // //         /* ---------- responsive ---------- */
// // // // // //         @media (max-width:1040px){
// // // // // //           .hlc-offer__row{ grid-template-columns:repeat(2,minmax(0,1fr)); }
// // // // // //         }
// // // // // //         @media (max-width:620px){
// // // // // //           .hlc-offer__lamps{ width:52vw; opacity:.5; }
// // // // // //           .hlc-offer__row{ grid-template-columns:1fr; }
// // // // // //           .offer-card{ grid-template-columns:minmax(0,1fr) 88px; padding:16px; }
// // // // // //           .offer-card__plate{ width:88px; height:88px; }
// // // // // //         }

// // // // // //         @media (prefers-reduced-motion:reduce){
// // // // // //           .offer-card,
// // // // // //           .offer-card__plate,
// // // // // //           .offer-card__plate img,
// // // // // //           .offer-card__icon,
// // // // // //           .offer-card__cta i{ transition:none; }
// // // // // //           .offer-card:hover{ transform:none; }
// // // // // //           .offer-card:hover .offer-card__plate img{ transform:none; }
// // // // // //         }
// // // // // //       `}</style>

// // // // // //       <section id="offer" className="hlc-offer" aria-labelledby="offer-title">
// // // // // //         <svg
// // // // // //           className="hlc-offer__lamps"
// // // // // //           viewBox="0 0 420 300"
// // // // // //           fill="none"
// // // // // //           aria-hidden="true"
// // // // // //           focusable="false"
// // // // // //         >
// // // // // //           <defs>
// // // // // //             <linearGradient id="hlcShade" x1="0" y1="0" x2="0" y2="1">
// // // // // //               <stop offset="0%" stopColor="#ffffff" />
// // // // // //               <stop offset="100%" stopColor="#dccfee" />
// // // // // //             </linearGradient>
// // // // // //             <radialGradient id="hlcLampGlow">
// // // // // //               <stop offset="0%" stopColor="#ffffff" stopOpacity="0.8" />
// // // // // //               <stop offset="100%" stopColor="#e4d1f4" stopOpacity="0" />
// // // // // //             </radialGradient>
// // // // // //           </defs>

// // // // // //           <line x1="120" y1="0" x2="120" y2="96" stroke="#cdbce3" strokeWidth="1.5" />
// // // // // //           <path d="M107 96h26l26 44q-39 11-78 0Z" fill="url(#hlcShade)" />
// // // // // //           <ellipse cx="120" cy="140" rx="39" ry="7" fill="#cfbee5" opacity=".5" />
// // // // // //           <ellipse cx="120" cy="152" rx="34" ry="26" fill="url(#hlcLampGlow)" />

// // // // // //           <line x1="228" y1="0" x2="228" y2="54" stroke="#cdbce3" strokeWidth="1.5" />
// // // // // //           <path d="M214 54h28l29 48q-43 12-86 0Z" fill="url(#hlcShade)" />
// // // // // //           <ellipse cx="228" cy="102" rx="43" ry="8" fill="#cfbee5" opacity=".5" />
// // // // // //           <ellipse cx="228" cy="116" rx="38" ry="29" fill="url(#hlcLampGlow)" />

// // // // // //           <line x1="330" y1="0" x2="330" y2="120" stroke="#cdbce3" strokeWidth="1.5" />
// // // // // //           <path d="M319 120h22l22 37q-33 9-66 0Z" fill="url(#hlcShade)" />
// // // // // //           <ellipse cx="330" cy="157" rx="33" ry="6" fill="#cfbee5" opacity=".5" />
// // // // // //           <ellipse cx="330" cy="168" rx="29" ry="22" fill="url(#hlcLampGlow)" />
// // // // // //         </svg>

// // // // // //         <div className="hlc-offer__inner">
// // // // // //           <header className="hlc-offer__head">
// // // // // //             <p className="hlc-offer__eyebrow">Our lighting collection</p>
// // // // // //             <h2 id="offer-title" className="hlc-offer__title">
// // // // // //               Every space needs a <em>different</em> light.
// // // // // //             </h2>
// // // // // //             <p className="hlc-offer__sub">
// // // // // //               Six product families covering homes, offices, retail floors and
// // // // // //               outdoor sites. Pick a family to see the full range.
// // // // // //             </p>
// // // // // //           </header>

// // // // // //           {CATEGORIES.length === 0 ? (
// // // // // //             <p className="hlc-offer__empty">No categories available right now.</p>
// // // // // //           ) : (
// // // // // //             <div className="hlc-offer__row">
// // // // // //               {CATEGORIES.map((category, i) => (
// // // // // //                 <motion.button
// // // // // //                   key={category.id}
// // // // // //                   type="button"
// // // // // //                   className="offer-card"
// // // // // //                   onClick={() => handleNavigate(category)}
// // // // // //                   aria-label={`Explore ${category.title}`}
// // // // // //                   custom={i}
// // // // // //                   variants={cardMotion}
// // // // // //                   initial="hidden"
// // // // // //                   whileInView="show"
// // // // // //                   viewport={{ once: true, amount: 0.2 }}
// // // // // //                 >
// // // // // //                   <span>
// // // // // //                     <span className="offer-card__icon">
// // // // // //                       <Icon name={category.icon} />
// // // // // //                     </span>
// // // // // //                     <h3 className="offer-card__title">{category.title}</h3>
// // // // // //                     <p className="offer-card__text">{category.description}</p>
// // // // // //                     <span className="offer-card__cta">
// // // // // //                       Explore <i aria-hidden="true">→</i>
// // // // // //                     </span>
// // // // // //                   </span>

// // // // // //                   <span className="offer-card__plate">
// // // // // //                     {category.image && (
// // // // // //                       <img
// // // // // //                         src={category.image}
// // // // // //                         alt=""
// // // // // //                         loading="lazy"
// // // // // //                         decoding="async"
// // // // // //                       />
// // // // // //                     )}
// // // // // //                   </span>
// // // // // //                 </motion.button>
// // // // // //               ))}
// // // // // //             </div>
// // // // // //           )}
// // // // // //         </div>
// // // // // //       </section>
// // // // // //     </>
// // // // // //   );
// // // // // // };

// // // // // // export default OfferSection;


// // // // // import React from "react";
// // // // // import { useNavigate } from "react-router-dom";
// // // // // import { motion } from "framer-motion";
// // // // // import LedBulbImg from "../assets/products/3.png";
// // // // // import DownlightImg from "../assets/products/9.png";
// // // // // import PanelImg from "../assets/products/28.png";
// // // // // import FloodImg from "../assets/products/31.png";
// // // // // import RopeImg from "../assets/products/35.png";

// // // // // /* ---------- small line icons, one per family ---------- */
// // // // // const Icon = ({ name }) => {
// // // // //   const common = {
// // // // //     width: 18,
// // // // //     height: 18,
// // // // //     viewBox: "0 0 24 24",
// // // // //     fill: "none",
// // // // //     stroke: "currentColor",
// // // // //     strokeWidth: 1.8,
// // // // //     strokeLinecap: "round",
// // // // //     strokeLinejoin: "round",
// // // // //     "aria-hidden": "true",
// // // // //   };
// // // // //   switch (name) {
// // // // //     case "bulb":
// // // // //       return (<svg {...common}><path d="M9 18h6M10 21h4M12 3a6 6 0 0 0-3.5 10.9c.5.4.8 1 .8 1.6V16h5.4v-.5c0-.6.3-1.2.8-1.6A6 6 0 0 0 12 3Z" /></svg>);
// // // // //     case "downlight":
// // // // //       return (<svg {...common}><circle cx="12" cy="9" r="5" /><path d="M6 20h12M8.5 16.5 7 20M15.5 16.5 17 20" /></svg>);
// // // // //     case "tube":
// // // // //       return (<svg {...common}><rect x="3" y="9" width="18" height="6" rx="3" /><path d="M7 12h10" /></svg>);
// // // // //     case "panel":
// // // // //       return (<svg {...common}><rect x="4" y="4" width="16" height="16" rx="2" /><path d="M9 9h6v6H9z" /></svg>);
// // // // //     case "flood":
// // // // //       return (<svg {...common}><rect x="4" y="5" width="12" height="9" rx="1.5" /><path d="M16 8.5h4M10 14v5M7 19h6" /></svg>);
// // // // //     default:
// // // // //       return (<svg {...common}><circle cx="7" cy="9" r="2" /><circle cx="14" cy="15" r="2" /><circle cx="18" cy="7" r="2" /></svg>);
// // // // //   }
// // // // // };

// // // // // /* ================= STATIC LOCAL CATEGORIES =================
// // // // //    `dbCategory` must match the real `products.category` value in MySQL exactly. */
// // // // // const CATEGORIES = [
// // // // //   { id: "led-bulbs", title: "LED Bulb Series", dbCategory: "LED BULB SERIES", description: "Reliable, efficient bulbs for every home and office.", image: LedBulbImg, icon: "bulb", subcategories: [] },
// // // // //   { id: "downlights", title: "Downlights & COB", dbCategory: "DOWNLIGHT SERIES", description: "Sleek COB and SMD downlights for modern interiors.", image: DownlightImg, icon: "downlight", subcategories: [] },
// // // // //   { id: "batten-tube", title: "Batten & Tube Series", dbCategory: "BATTEN AND LED TUBE SERIES", description: "Durable, bright tube lights and battens for all spaces.", image: DownlightImg, icon: "tube", subcategories: [] },
// // // // //   { id: "panel-lights", title: "Panel & Ceiling Lights", dbCategory: "PANEL LIGHT SERIES", description: "Modern panels for a clean, even ceiling finish.", image: PanelImg, icon: "panel", subcategories: [] },
// // // // //   { id: "flood-outdoor", title: "Flood & Outdoor", dbCategory: "STREET AND FLOOD LIGHT SERIES", description: "High-output flood and street lighting built for weather.", image: FloodImg, icon: "flood", subcategories: [] },
// // // // //   { id: "rope-decorative", title: "Rope & Decorative", dbCategory: "ROPE LIGHT SERIES", description: "Rope and strip lighting for accent and ambience.", image: RopeImg, icon: "rope", subcategories: [] },
// // // // // ];

// // // // // const cardMotion = {
// // // // //   hidden: { opacity: 0, y: 18 },
// // // // //   show: (i) => ({ opacity: 1, y: 0, transition: { duration: 0.55, delay: i * 0.07, ease: [0.16, 1, 0.3, 1] } }),
// // // // // };

// // // // // /* glow-orb tint per card, cycling the reference's pink→lilac→blue palette */
// // // // // const ORB = ["#f4a9c4", "#e6a9d6", "#c9b3e8", "#f0aecb", "#d3b0e6", "#b9c2ec"];

// // // // // const OfferSection = () => {
// // // // //   const navigate = useNavigate();
// // // // //   const handleNavigate = (category) => {
// // // // //     navigate("/product-by-categories", {
// // // // //       state: { category: category.dbCategory, subcategories: category.subcategories || [] },
// // // // //     });
// // // // //   };

// // // // //   return (
// // // // //     <>
// // // // //       <style>{`
// // // // //         #offer.hlc-offer{
// // // // //           --magenta:#9b1f6c;
// // // // //           --plum:#542757;
// // // // //           --navy:#241c2e;
// // // // //           --ink:#1c1622;
// // // // //           --muted:#6b6480;
// // // // //           --ease:cubic-bezier(.16,1,.3,1);
// // // // //           position:relative;
// // // // //           width:100%;
// // // // //           padding:clamp(52px,7vw,92px) 0 clamp(56px,7vw,96px);
// // // // //           /* iridescent scene lifted from the reference: warm pink TL,
// // // // //              magenta-lilac TR, lavender BL, cool blue BR */
// // // // //           background:
// // // // //             radial-gradient(120% 120% at 8% 0%, rgba(244,196,206,.85) 0%, transparent 46%),
// // // // //             radial-gradient(120% 120% at 100% 4%, rgba(224,186,224,.8) 0%, transparent 48%),
// // // // //             radial-gradient(130% 120% at 0% 100%, rgba(206,196,232,.75) 0%, transparent 50%),
// // // // //             radial-gradient(130% 120% at 100% 100%, rgba(196,206,232,.7) 0%, transparent 52%),
// // // // //             linear-gradient(160deg,#f3ecf6 0%,#f7f2fa 50%,#f2eef8 100%);
// // // // //           font-family:"Manrope","Inter",system-ui,-apple-system,Segoe UI,Roboto,Arial,sans-serif;
// // // // //           color:var(--ink);
// // // // //           overflow:hidden;
// // // // //           isolation:isolate;
// // // // //         }

// // // // //         /* floating fixtures ghosted into the top corners, like the reference */
// // // // //         #offer.hlc-offer::before,
// // // // //         #offer.hlc-offer::after{
// // // // //           content:"";
// // // // //           position:absolute;
// // // // //           top:-4%;
// // // // //           width:min(340px,32vw);
// // // // //           height:min(210px,22vw);
// // // // //           background-repeat:no-repeat;
// // // // //           background-size:contain;
// // // // //           opacity:.5;
// // // // //           z-index:0;
// // // // //           pointer-events:none;
// // // // //           filter:blur(.3px);
// // // // //         }
// // // // //         #offer.hlc-offer::before{ left:24%;
// // // // //           background-image:radial-gradient(closed-side, transparent 60%, transparent 61%); }
// // // // //         /* subtle top vignette so cards read against the busy top */
// // // // //         .hlc-offer__topfade{
// // // // //           position:absolute; inset:0 0 auto 0; height:34%;
// // // // //           background:linear-gradient(180deg, rgba(255,255,255,.35), transparent);
// // // // //           z-index:0; pointer-events:none;
// // // // //         }

// // // // //         .hlc-offer__inner{
// // // // //           position:relative; z-index:2;
// // // // //           width:min(1180px,92vw); margin:0 auto;
// // // // //         }

// // // // //         /* ---------- header (left-aligned, like the reference) ---------- */
// // // // //         .hlc-offer__head{ max-width:560px; margin:0 0 clamp(30px,3.6vw,46px); }
// // // // //         .hlc-offer__brand{ margin:0 0 14px; font-size:13px; font-weight:800; letter-spacing:.06em; color:var(--ink); text-transform:uppercase; }
// // // // //         .hlc-offer__title{
// // // // //           margin:0 0 14px;
// // // // //           font-family:"Sora","Manrope",sans-serif;
// // // // //           font-size:clamp(30px,4.4vw,52px);
// // // // //           font-weight:700; line-height:1.08; letter-spacing:-.03em; color:var(--ink);
// // // // //         }
// // // // //         .hlc-offer__title em{ font-style:normal; color:var(--magenta); }
// // // // //         .hlc-offer__sub{ margin:0; max-width:440px; font-size:15px; line-height:1.6; color:var(--muted); }

// // // // //         /* ---------- grid ---------- */
// // // // //         .hlc-offer__row{
// // // // //           display:grid; grid-template-columns:repeat(3,minmax(0,1fr));
// // // // //           gap:clamp(16px,1.8vw,22px);
// // // // //         }

// // // // //         /* ---------- frosted glass card (the reference signature) ---------- */
// // // // //         .offer-card{
// // // // //           -webkit-appearance:none; appearance:none; border:0; margin:0;
// // // // //           font:inherit; color:inherit; text-align:left; cursor:pointer;
// // // // //           position:relative; isolation:isolate;
// // // // //           display:grid; grid-template-columns:minmax(0,1fr) 116px; align-items:center; gap:14px;
// // // // //           padding:22px;
// // // // //           border-radius:20px;
// // // // //           background:rgba(255,255,255,.42);
// // // // //           border:1px solid rgba(255,255,255,.7);
// // // // //           box-shadow:0 1px 1px rgba(255,255,255,.6) inset, 0 12px 34px rgba(84,39,87,.10);
// // // // //           -webkit-backdrop-filter:blur(14px) saturate(1.3);
// // // // //           backdrop-filter:blur(14px) saturate(1.3);
// // // // //           overflow:hidden;
// // // // //           transition:transform .45s var(--ease), box-shadow .45s var(--ease), background .45s var(--ease);
// // // // //         }
// // // // //         .offer-card:hover{
// // // // //           transform:translateY(-6px);
// // // // //           background:rgba(255,255,255,.56);
// // // // //           box-shadow:0 1px 1px rgba(255,255,255,.7) inset, 0 24px 50px rgba(155,31,108,.18);
// // // // //         }
// // // // //         .offer-card:focus-visible{ outline:2px solid var(--magenta); outline-offset:3px; }

// // // // //         /* the soft glow orb sitting behind the product image */
// // // // //         .offer-card__orb{
// // // // //           position:absolute; z-index:-1;
// // // // //           right:14px; top:50%; transform:translateY(-50%);
// // // // //           width:120px; height:120px; border-radius:50%;
// // // // //           filter:blur(22px); opacity:.7;
// // // // //           transition:opacity .45s var(--ease), transform .45s var(--ease);
// // // // //         }
// // // // //         .offer-card:hover .offer-card__orb{ opacity:.95; transform:translateY(-50%) scale(1.08); }

// // // // //         .offer-card__icon{
// // // // //           display:grid; place-items:center; width:34px; height:34px; margin-bottom:13px;
// // // // //           border-radius:50%;
// // // // //           background:rgba(155,31,108,.10); color:var(--magenta);
// // // // //           transition:background .4s var(--ease), color .4s var(--ease);
// // // // //         }
// // // // //         .offer-card:hover .offer-card__icon{ background:var(--magenta); color:#fff; }

// // // // //         .offer-card__title{ margin:0 0 6px; font-size:16px; font-weight:800; line-height:1.25; letter-spacing:-.01em; color:var(--ink); }
// // // // //         .offer-card__text{
// // // // //           margin:0 0 14px; font-size:12.5px; line-height:1.5; color:var(--muted);
// // // // //           display:-webkit-box; -webkit-line-clamp:2; -webkit-box-orient:vertical; overflow:hidden;
// // // // //         }
// // // // //         .offer-card__cta{
// // // // //           display:inline-flex; align-items:center; gap:7px;
// // // // //           font-size:11px; font-weight:800; letter-spacing:.16em; text-transform:uppercase; color:var(--magenta);
// // // // //         }
// // // // //         .offer-card__cta i{ font-style:normal; transition:transform .4s var(--ease); }
// // // // //         .offer-card:hover .offer-card__cta i{ transform:translateX(5px); }

// // // // //         .offer-card__plate{ position:relative; width:116px; height:116px; display:grid; place-items:center; }
// // // // //         .offer-card__plate img{
// // // // //           max-width:100%; max-height:100%; object-fit:contain;
// // // // //           filter:drop-shadow(0 10px 18px rgba(84,39,87,.22));
// // // // //           transition:transform .45s var(--ease);
// // // // //         }
// // // // //         .offer-card:hover .offer-card__plate img{ transform:scale(1.07) rotate(-2deg); }

// // // // //         .hlc-offer__empty{ padding:40px 0; font-size:15px; color:var(--muted); }

// // // // //         /* ---------- responsive ---------- */
// // // // //         @media (max-width:1040px){ .hlc-offer__row{ grid-template-columns:repeat(2,minmax(0,1fr)); } }
// // // // //         @media (max-width:600px){
// // // // //           .hlc-offer__row{ grid-template-columns:1fr; }
// // // // //           .offer-card{ grid-template-columns:minmax(0,1fr) 96px; padding:18px; }
// // // // //           .offer-card__plate{ width:96px; height:96px; }
// // // // //           .offer-card__orb{ width:96px; height:96px; }
// // // // //         }
// // // // //         @media (prefers-reduced-motion:reduce){
// // // // //           .offer-card, .offer-card__plate img, .offer-card__icon, .offer-card__cta i, .offer-card__orb{ transition:none; }
// // // // //           .offer-card:hover{ transform:none; }
// // // // //           .offer-card:hover .offer-card__plate img{ transform:none; }
// // // // //         }
// // // // //       `}</style>

// // // // //       <section id="offer" className="hlc-offer" aria-labelledby="offer-title">
// // // // //         <div className="hlc-offer__topfade" />
// // // // //         <div className="hlc-offer__inner">
// // // // //           <header className="hlc-offer__head">
// // // // //             <p className="hlc-offer__brand">HLC</p>
// // // // //             <h2 id="offer-title" className="hlc-offer__title">
// // // // //               Every space needs a <em>different</em> light.
// // // // //             </h2>
// // // // //             <p className="hlc-offer__sub">
// // // // //               Six product families covering homes, offices, retail floors and
// // // // //               outdoor sites. Pick a family to see the full range.
// // // // //             </p>
// // // // //           </header>

// // // // //           {CATEGORIES.length === 0 ? (
// // // // //             <p className="hlc-offer__empty">No categories available right now.</p>
// // // // //           ) : (
// // // // //             <div className="hlc-offer__row">
// // // // //               {CATEGORIES.map((category, i) => (
// // // // //                 <motion.button
// // // // //                   key={category.id}
// // // // //                   type="button"
// // // // //                   className="offer-card"
// // // // //                   onClick={() => handleNavigate(category)}
// // // // //                   aria-label={`Explore ${category.title}`}
// // // // //                   custom={i}
// // // // //                   variants={cardMotion}
// // // // //                   initial="hidden"
// // // // //                   whileInView="show"
// // // // //                   viewport={{ once: true, amount: 0.2 }}
// // // // //                 >
// // // // //                   <span className="offer-card__orb" style={{ background: ORB[i % ORB.length] }} />
// // // // //                   <span>
// // // // //                     <span className="offer-card__icon"><Icon name={category.icon} /></span>
// // // // //                     <h3 className="offer-card__title">{category.title}</h3>
// // // // //                     <p className="offer-card__text">{category.description}</p>
// // // // //                     <span className="offer-card__cta">Explore <i aria-hidden="true">→</i></span>
// // // // //                   </span>
// // // // //                   <span className="offer-card__plate">
// // // // //                     {category.image && (
// // // // //                       <img src={category.image} alt="" loading="lazy" decoding="async" />
// // // // //                     )}
// // // // //                   </span>
// // // // //                 </motion.button>
// // // // //               ))}
// // // // //             </div>
// // // // //           )}
// // // // //         </div>
// // // // //       </section>
// // // // //     </>
// // // // //   );
// // // // // };

// // // // // export default OfferSection;

// // // // // import React from "react";
// // // // // import { useNavigate } from "react-router-dom";
// // // // // import { motion } from "framer-motion";
// // // // // import LedBulbImg from "../assets/products/3.png";
// // // // // import DownlightImg from "../assets/products/9.png";
// // // // // import PanelImg from "../assets/products/28.png";
// // // // // import FloodImg from "../assets/products/31.png";
// // // // // import RopeImg from "../assets/products/35.png";

// // // // // /* ---------- small line icons, one per family ---------- */
// // // // // const Icon = ({ name }) => {
// // // // //   const common = {
// // // // //     width: 18,
// // // // //     height: 18,
// // // // //     viewBox: "0 0 24 24",
// // // // //     fill: "none",
// // // // //     stroke: "currentColor",
// // // // //     strokeWidth: 1.8,
// // // // //     strokeLinecap: "round",
// // // // //     strokeLinejoin: "round",
// // // // //     "aria-hidden": "true",
// // // // //   };
// // // // //   switch (name) {
// // // // //     case "bulb":
// // // // //       return (<svg {...common}><path d="M9 18h6M10 21h4M12 3a6 6 0 0 0-3.5 10.9c.5.4.8 1 .8 1.6V16h5.4v-.5c0-.6.3-1.2.8-1.6A6 6 0 0 0 12 3Z" /></svg>);
// // // // //     case "downlight":
// // // // //       return (<svg {...common}><circle cx="12" cy="9" r="5" /><path d="M6 20h12M8.5 16.5 7 20M15.5 16.5 17 20" /></svg>);
// // // // //     case "tube":
// // // // //       return (<svg {...common}><rect x="3" y="9" width="18" height="6" rx="3" /><path d="M7 12h10" /></svg>);
// // // // //     case "panel":
// // // // //       return (<svg {...common}><rect x="4" y="4" width="16" height="16" rx="2" /><path d="M9 9h6v6H9z" /></svg>);
// // // // //     case "flood":
// // // // //       return (<svg {...common}><rect x="4" y="5" width="12" height="9" rx="1.5" /><path d="M16 8.5h4M10 14v5M7 19h6" /></svg>);
// // // // //     default:
// // // // //       return (<svg {...common}><circle cx="7" cy="9" r="2" /><circle cx="14" cy="15" r="2" /><circle cx="18" cy="7" r="2" /></svg>);
// // // // //   }
// // // // // };

// // // // // /* ================= STATIC LOCAL CATEGORIES =================
// // // // //    `dbCategory` must match the real `products.category` value in MySQL exactly. */
// // // // // const CATEGORIES = [
// // // // //   { id: "led-bulbs", title: "LED Bulb Series", dbCategory: "LED BULB SERIES", description: "Reliable, efficient bulbs for every home and office.", image: LedBulbImg, icon: "bulb", subcategories: [] },
// // // // //   { id: "downlights", title: "Downlights & COB", dbCategory: "DOWNLIGHT SERIES", description: "Sleek COB and SMD downlights for modern interiors.", image: DownlightImg, icon: "downlight", subcategories: [] },
// // // // //   { id: "batten-tube", title: "Batten & Tube Series", dbCategory: "BATTEN AND LED TUBE SERIES", description: "Durable, bright tube lights and battens for all spaces.", image: DownlightImg, icon: "tube", subcategories: [] },
// // // // //   { id: "panel-lights", title: "Panel & Ceiling Lights", dbCategory: "PANEL LIGHT SERIES", description: "Modern panels for a clean, even ceiling finish.", image: PanelImg, icon: "panel", subcategories: [] },
// // // // //   { id: "flood-outdoor", title: "Flood & Outdoor", dbCategory: "STREET AND FLOOD LIGHT SERIES", description: "High-output flood and street lighting built for weather.", image: FloodImg, icon: "flood", subcategories: [] },
// // // // //   { id: "rope-decorative", title: "Rope & Decorative", dbCategory: "ROPE LIGHT SERIES", description: "Rope and strip lighting for accent and ambience.", image: RopeImg, icon: "rope", subcategories: [] },
// // // // // ];

// // // // // const cardMotion = {
// // // // //   hidden: { opacity: 0, y: 18 },
// // // // //   show: (i) => ({ opacity: 1, y: 0, transition: { duration: 0.55, delay: i * 0.07, ease: [0.16, 1, 0.3, 1] } }),
// // // // // };

// // // // // /* glow-orb tint per card, cycling the reference's pink→lilac→blue palette */
// // // // // const ORB = ["#f4a9c4", "#e6a9d6", "#c9b3e8", "#f0aecb", "#d3b0e6", "#b9c2ec"];

// // // // // const OfferSection = () => {
// // // // //   const navigate = useNavigate();
// // // // //   const handleNavigate = (category) => {
// // // // //     navigate("/product-by-categories", {
// // // // //       state: { category: category.dbCategory, subcategories: category.subcategories || [] },
// // // // //     });
// // // // //   };

// // // // //   return (
// // // // //     <>
// // // // //       <style>{`
// // // // //         #offer.hlc-offer{
// // // // //           --magenta:#9b1f6c;
// // // // //           --plum:#542757;
// // // // //           --navy:#241c2e;
// // // // //           --ink:#1c1622;
// // // // //           --muted:#6b6480;
// // // // //           --ease:cubic-bezier(.16,1,.3,1);
// // // // //           position:relative;
// // // // //           width:100%;
// // // // //           padding:clamp(52px,7vw,92px) 0 clamp(56px,7vw,96px);
// // // // //           /* iridescent scene lifted from the reference: warm pink TL,
// // // // //              magenta-lilac TR, lavender BL, cool blue BR */
// // // // //           background:
// // // // //             radial-gradient(120% 120% at 8% 0%, rgba(244,196,206,.85) 0%, transparent 46%),
// // // // //             radial-gradient(120% 120% at 100% 4%, rgba(224,186,224,.8) 0%, transparent 48%),
// // // // //             radial-gradient(130% 120% at 0% 100%, rgba(206,196,232,.75) 0%, transparent 50%),
// // // // //             radial-gradient(130% 120% at 100% 100%, rgba(196,206,232,.7) 0%, transparent 52%),
// // // // //             linear-gradient(160deg,#f3ecf6 0%,#f7f2fa 50%,#f2eef8 100%);
// // // // //           font-family:"Manrope","Inter",system-ui,-apple-system,Segoe UI,Roboto,Arial,sans-serif;
// // // // //           color:var(--ink);
// // // // //           overflow:hidden;
// // // // //           isolation:isolate;
// // // // //         }

// // // // //         /* floating fixtures ghosted into the top corners, like the reference */
// // // // //         #offer.hlc-offer::before,
// // // // //         #offer.hlc-offer::after{
// // // // //           content:"";
// // // // //           position:absolute;
// // // // //           top:-4%;
// // // // //           width:min(340px,32vw);
// // // // //           height:min(210px,22vw);
// // // // //           background-repeat:no-repeat;
// // // // //           background-size:contain;
// // // // //           opacity:.5;
// // // // //           z-index:0;
// // // // //           pointer-events:none;
// // // // //           filter:blur(.3px);
// // // // //         }
// // // // //         #offer.hlc-offer::before{ left:24%;
// // // // //           background-image:radial-gradient(closed-side, transparent 60%, transparent 61%); }
// // // // //         /* subtle top vignette so cards read against the busy top */
// // // // //         .hlc-offer__topfade{
// // // // //           position:absolute; inset:0 0 auto 0; height:34%;
// // // // //           background:linear-gradient(180deg, rgba(255,255,255,.35), transparent);
// // // // //           z-index:0; pointer-events:none;
// // // // //         }

// // // // //         .hlc-offer__inner{
// // // // //           position:relative; z-index:2;
// // // // //           width:min(1180px,92vw); margin:0 auto;
// // // // //         }

// // // // //         /* ---------- header (left-aligned, like the reference) ---------- */
// // // // //         .hlc-offer__head{ max-width:560px; margin:0 0 clamp(30px,3.6vw,46px); }
// // // // //         .hlc-offer__brand{ margin:0 0 14px; font-size:13px; font-weight:800; letter-spacing:.06em; color:var(--ink); text-transform:uppercase; }
// // // // //         .hlc-offer__title{
// // // // //           margin:0 0 14px;
// // // // //           font-family:"Sora","Manrope",sans-serif;
// // // // //           font-size:clamp(30px,4.4vw,52px);
// // // // //           font-weight:700; line-height:1.08; letter-spacing:-.03em; color:var(--ink);
// // // // //         }
// // // // //         .hlc-offer__title em{ font-style:normal; color:var(--magenta); }
// // // // //         .hlc-offer__sub{ margin:0; max-width:440px; font-size:15px; line-height:1.6; color:var(--muted); }

// // // // //         /* ---------- grid ---------- */
// // // // //         .hlc-offer__row{
// // // // //           display:grid; grid-template-columns:repeat(3,minmax(0,1fr));
// // // // //           gap:clamp(16px,1.8vw,22px);
// // // // //           perspective:1200px;
// // // // //         }

// // // // //         /* ---------- frosted glass card — highly transparent, premium ---------- */
// // // // //         .offer-card{
// // // // //           -webkit-appearance:none; appearance:none; margin:0;
// // // // //           font:inherit; color:inherit; text-align:left; cursor:pointer;
// // // // //           position:relative; isolation:isolate;
// // // // //           display:grid; grid-template-columns:minmax(0,1fr) 132px; align-items:center; gap:16px;
// // // // //           padding:26px 26px 26px 28px;
// // // // //           border-radius:22px;
// // // // //           /* glass is barely there — orbs + scene show through */
// // // // //           background:linear-gradient(135deg, rgba(255,255,255,.22), rgba(255,255,255,.08));
// // // // //           border:1px solid rgba(255,255,255,.55);
// // // // //           box-shadow:
// // // // //             0 1px 1px rgba(255,255,255,.5) inset,
// // // // //             0 1px 30px rgba(255,255,255,.12) inset,
// // // // //             0 18px 44px rgba(84,39,87,.10);
// // // // //           -webkit-backdrop-filter:blur(8px) saturate(1.25);
// // // // //           backdrop-filter:blur(8px) saturate(1.25);
// // // // //           overflow:hidden;
// // // // //           transform:perspective(900px) rotateX(0deg) rotateY(0deg) translateZ(0);
// // // // //           transform-style:preserve-3d;
// // // // //           transition:transform .5s var(--ease), box-shadow .5s var(--ease), background .5s var(--ease), border-color .5s var(--ease);
// // // // //         }
// // // // //         /* glowing edge highlight — like the active card in the reference */
// // // // //         .offer-card::after{
// // // // //           content:""; position:absolute; inset:0; border-radius:22px; padding:1px;
// // // // //           background:linear-gradient(135deg, rgba(255,255,255,.9), rgba(155,31,108,.35) 40%, transparent 70%);
// // // // //           -webkit-mask:linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0);
// // // // //           -webkit-mask-composite:xor; mask-composite:exclude;
// // // // //           opacity:0; transition:opacity .5s var(--ease); pointer-events:none;
// // // // //         }
// // // // //         .offer-card:hover{
// // // // //           transform:perspective(900px) rotateX(4deg) rotateY(-5deg) translateY(-8px) translateZ(20px);
// // // // //           background:linear-gradient(135deg, rgba(255,255,255,.34), rgba(255,255,255,.14));
// // // // //           border-color:rgba(255,255,255,.8);
// // // // //           box-shadow:
// // // // //             0 1px 1px rgba(255,255,255,.6) inset,
// // // // //             0 30px 66px rgba(155,31,108,.22);
// // // // //         }
// // // // //         .offer-card:hover::after{ opacity:1; }
// // // // //         .offer-card:focus-visible{ outline:2px solid var(--magenta); outline-offset:3px; }

// // // // //         /* big soft glow orbs bleeding across the card */
// // // // //         .offer-card__orb{
// // // // //           position:absolute; z-index:-1;
// // // // //           right:6%; top:50%; transform:translateY(-50%);
// // // // //           width:180px; height:180px; border-radius:50%;
// // // // //           filter:blur(38px); opacity:.6;
// // // // //           transition:opacity .5s var(--ease), transform .5s var(--ease);
// // // // //         }
// // // // //         .offer-card__orb--2{
// // // // //           left:14%; right:auto; top:64%;
// // // // //           width:130px; height:130px; filter:blur(42px); opacity:.4;
// // // // //         }
// // // // //         .offer-card:hover .offer-card__orb{ opacity:.85; transform:translateY(-50%) scale(1.12); }

// // // // //         .offer-card__icon{
// // // // //           display:grid; place-items:center; width:36px; height:36px; margin-bottom:16px;
// // // // //           border-radius:50%;
// // // // //           background:rgba(255,255,255,.5); color:var(--magenta);
// // // // //           -webkit-backdrop-filter:blur(6px); backdrop-filter:blur(6px);
// // // // //           transition:background .4s var(--ease), color .4s var(--ease);
// // // // //         }
// // // // //         .offer-card:hover .offer-card__icon{ background:var(--magenta); color:#fff; }

// // // // //         .offer-card__title{ margin:0 0 7px; font-size:17px; font-weight:800; line-height:1.22; letter-spacing:-.01em; color:var(--ink); }
// // // // //         .offer-card__text{
// // // // //           margin:0 0 16px; font-size:13px; line-height:1.5; color:var(--muted);
// // // // //           display:-webkit-box; -webkit-line-clamp:2; -webkit-box-orient:vertical; overflow:hidden;
// // // // //         }
// // // // //         .offer-card__cta{
// // // // //           display:inline-flex; align-items:center; gap:8px;
// // // // //           font-size:11px; font-weight:800; letter-spacing:.16em; text-transform:uppercase; color:var(--magenta);
// // // // //         }
// // // // //         .offer-card__cta i{ font-style:normal; transition:transform .4s var(--ease); }
// // // // //         .offer-card:hover .offer-card__cta i{ transform:translateX(5px); }

// // // // //         /* inner translucent product tile — the reference sits products on this */
// // // // //         .offer-card__plate{
// // // // //           position:relative; width:132px; height:132px; border-radius:16px;
// // // // //           display:grid; place-items:center;
// // // // //           background:linear-gradient(150deg, rgba(255,255,255,.5), rgba(255,255,255,.18));
// // // // //           border:1px solid rgba(255,255,255,.6);
// // // // //           box-shadow:0 1px 1px rgba(255,255,255,.5) inset, 0 8px 22px rgba(84,39,87,.10);
// // // // //           -webkit-backdrop-filter:blur(6px); backdrop-filter:blur(6px);
// // // // //           transition:transform .5s var(--ease), box-shadow .5s var(--ease);
// // // // //         }
// // // // //         .offer-card:hover .offer-card__plate{ transform:translateZ(30px) scale(1.04); box-shadow:0 16px 34px rgba(84,39,87,.2); }
// // // // //         .offer-card__plate img{
// // // // //           max-width:82%; max-height:82%; object-fit:contain;
// // // // //           filter:drop-shadow(0 8px 16px rgba(84,39,87,.28));
// // // // //           transition:transform .5s var(--ease);
// // // // //         }
// // // // //         .offer-card:hover .offer-card__plate img{ transform:scale(1.08); }

// // // // //         .hlc-offer__empty{ padding:40px 0; font-size:15px; color:var(--muted); }

// // // // //         /* ---------- responsive ---------- */
// // // // //         @media (max-width:1040px){ .hlc-offer__row{ grid-template-columns:repeat(2,minmax(0,1fr)); } }
// // // // //         @media (max-width:600px){
// // // // //           .hlc-offer__row{ grid-template-columns:1fr; }
// // // // //           .offer-card{ grid-template-columns:minmax(0,1fr) 108px; padding:20px; }
// // // // //           .offer-card__plate{ width:108px; height:108px; }
// // // // //           .offer-card__orb{ width:140px; height:140px; }
// // // // //           /* disable 3D tilt on touch — no hover, and it can feel jittery */
// // // // //           .offer-card:hover{ transform:translateY(-6px); }
// // // // //         }
// // // // //         @media (prefers-reduced-motion:reduce){
// // // // //           .offer-card, .offer-card__plate, .offer-card__plate img, .offer-card__icon, .offer-card__cta i, .offer-card__orb{ transition:none; }
// // // // //           .offer-card, .offer-card:hover{ transform:none; }
// // // // //           .offer-card:hover .offer-card__plate{ transform:none; }
// // // // //           .offer-card:hover .offer-card__plate img{ transform:none; }
// // // // //         }
// // // // //       `}</style>

// // // // //       <section id="offer" className="hlc-offer" aria-labelledby="offer-title">
// // // // //         <div className="hlc-offer__topfade" />
// // // // //         <div className="hlc-offer__inner">
// // // // //           <header className="hlc-offer__head">
// // // // //             <p className="hlc-offer__brand">HLC</p>
// // // // //             <h2 id="offer-title" className="hlc-offer__title">
// // // // //               Every space needs a <em>different</em> light.
// // // // //             </h2>
// // // // //             <p className="hlc-offer__sub">
// // // // //               Six product families covering homes, offices, retail floors and
// // // // //               outdoor sites. Pick a family to see the full range.
// // // // //             </p>
// // // // //           </header>

// // // // //           {CATEGORIES.length === 0 ? (
// // // // //             <p className="hlc-offer__empty">No categories available right now.</p>
// // // // //           ) : (
// // // // //             <div className="hlc-offer__row">
// // // // //               {CATEGORIES.map((category, i) => (
// // // // //                 <motion.button
// // // // //                   key={category.id}
// // // // //                   type="button"
// // // // //                   className="offer-card"
// // // // //                   onClick={() => handleNavigate(category)}
// // // // //                   aria-label={`Explore ${category.title}`}
// // // // //                   custom={i}
// // // // //                   variants={cardMotion}
// // // // //                   initial="hidden"
// // // // //                   whileInView="show"
// // // // //                   viewport={{ once: true, amount: 0.2 }}
// // // // //                 >
// // // // //                   <span className="offer-card__orb" style={{ background: ORB[i % ORB.length] }} />
// // // // //                   <span className="offer-card__orb offer-card__orb--2" style={{ background: ORB[(i + 3) % ORB.length] }} />
// // // // //                   <span>
// // // // //                     <span className="offer-card__icon"><Icon name={category.icon} /></span>
// // // // //                     <h3 className="offer-card__title">{category.title}</h3>
// // // // //                     <p className="offer-card__text">{category.description}</p>
// // // // //                     <span className="offer-card__cta">Explore <i aria-hidden="true">→</i></span>
// // // // //                   </span>
// // // // //                   <span className="offer-card__plate">
// // // // //                     {category.image && (
// // // // //                       <img src={category.image} alt="" loading="lazy" decoding="async" />
// // // // //                     )}
// // // // //                   </span>
// // // // //                 </motion.button>
// // // // //               ))}
// // // // //             </div>
// // // // //           )}
// // // // //         </div>
// // // // //       </section>
// // // // //     </>
// // // // //   );
// // // // //   };

// // // // // export default OfferSection;



// // // // import React from "react";
// // // // import { useNavigate } from "react-router-dom";
// // // // import { motion } from "framer-motion";
// // // // import LedBulbImg from "../assets/products/3.png";
// // // // import DownlightImg from "../assets/products/9.png";
// // // // import PanelImg from "../assets/products/28.png";
// // // // import FloodImg from "../assets/products/flood-street.png";
// // // // import RopeImg from "../assets/products/rope-light.png";
// // // // import BattenImg from "../assets/products/batten.png";

// // // // /* ---------- small line icons, one per family ---------- */
// // // // const Icon = ({ name }) => {
// // // //   const common = {
// // // //     width: 18,
// // // //     height: 18,
// // // //     viewBox: "0 0 24 24",
// // // //     fill: "none",
// // // //     stroke: "currentColor",
// // // //     strokeWidth: 1.8,
// // // //     strokeLinecap: "round",
// // // //     strokeLinejoin: "round",
// // // //     "aria-hidden": "true",
// // // //   };
// // // //   switch (name) {
// // // //     case "bulb":
// // // //       return (<svg {...common}><path d="M9 18h6M10 21h4M12 3a6 6 0 0 0-3.5 10.9c.5.4.8 1 .8 1.6V16h5.4v-.5c0-.6.3-1.2.8-1.6A6 6 0 0 0 12 3Z" /></svg>);
// // // //     case "downlight":
// // // //       return (<svg {...common}><circle cx="12" cy="9" r="5" /><path d="M6 20h12M8.5 16.5 7 20M15.5 16.5 17 20" /></svg>);
// // // //     case "tube":
// // // //       return (<svg {...common}><rect x="3" y="9" width="18" height="6" rx="3" /><path d="M7 12h10" /></svg>);
// // // //     case "panel":
// // // //       return (<svg {...common}><rect x="4" y="4" width="16" height="16" rx="2" /><path d="M9 9h6v6H9z" /></svg>);
// // // //     case "flood":
// // // //       return (<svg {...common}><rect x="4" y="5" width="12" height="9" rx="1.5" /><path d="M16 8.5h4M10 14v5M7 19h6" /></svg>);
// // // //     default:
// // // //       return (<svg {...common}><circle cx="7" cy="9" r="2" /><circle cx="14" cy="15" r="2" /><circle cx="18" cy="7" r="2" /></svg>);
// // // //   }
// // // // };

// // // // /* ================= STATIC LOCAL CATEGORIES =================
// // // //    `dbCategory` must match the real `products.category` value in MySQL exactly. */
// // // // const CATEGORIES = [
// // // //   { id: "led-bulbs", title: "LED Bulb Series", dbCategory: "LED BULB SERIES", description: "Reliable, efficient bulbs for every home and office.", image: LedBulbImg, icon: "bulb", subcategories: [] },
// // // //   { id: "downlights", title: "Downlights & COB", dbCategory: "DOWNLIGHT SERIES", description: "Sleek COB and SMD downlights for modern interiors.", image: DownlightImg, icon: "downlight", subcategories: [] },
// // // //   { id: "batten-tube", title: "Batten & Tube Series", dbCategory: "BATTEN AND LED TUBE SERIES", description: "Durable, bright tube lights and battens for all spaces.", image: BattenImg, icon: "tube", subcategories: [] },
// // // //   { id: "panel-lights", title: "Panel & Ceiling Lights", dbCategory: "PANEL LIGHT SERIES", description: "Modern panels for a clean, even ceiling finish.", image: PanelImg, icon: "panel", subcategories: [] },
// // // //   { id: "flood-outdoor", title: "Flood & Outdoor", dbCategory: "STREET AND FLOOD LIGHT SERIES", description: "High-output flood and street lighting built for weather.", image: FloodImg, icon: "flood", subcategories: [] },
// // // //   { id: "rope-decorative", title: "Rope & Decorative", dbCategory: "ROPE LIGHT SERIES", description: "Rope and strip lighting for accent and ambience.", image: RopeImg, icon: "rope", subcategories: [] },
// // // // ];

// // // // const cardMotion = {
// // // //   hidden: { opacity: 0, y: 18 },
// // // //   show: (i) => ({ opacity: 1, y: 0, transition: { duration: 0.55, delay: i * 0.07, ease: [0.16, 1, 0.3, 1] } }),
// // // // };

// // // // /* glow-orb tint per card, cycling the reference's pink→lilac→blue palette */
// // // // const ORB = ["#f4a9c4", "#e6a9d6", "#c9b3e8", "#f0aecb", "#d3b0e6", "#b9c2ec"];

// // // // const OfferSection = () => {
// // // //   const navigate = useNavigate();
// // // //   const handleNavigate = (category) => {
// // // //     navigate("/product-by-categories", {
// // // //       state: { category: category.dbCategory, subcategories: category.subcategories || [] },
// // // //     });
// // // //   };

// // // //   return (
// // // //     <>
// // // //       <style>{`
// // // //         #offer.hlc-offer{
// // // //           --magenta:#9b1f6c;
// // // //           --plum:#542757;
// // // //           --navy:#241c2e;
// // // //           --ink:#1c1622;
// // // //           --muted:#6b6480;
// // // //           --ease:cubic-bezier(.16,1,.3,1);
// // // //           position:relative;
// // // //           width:100%;
// // // //           padding:clamp(52px,7vw,92px) 0 clamp(56px,7vw,96px);
// // // //           /* iridescent scene lifted from the reference: warm pink TL,
// // // //              magenta-lilac TR, lavender BL, cool blue BR */
// // // //           background:
// // // //             radial-gradient(120% 120% at 8% 0%, rgba(244,196,206,.85) 0%, transparent 46%),
// // // //             radial-gradient(120% 120% at 100% 4%, rgba(224,186,224,.8) 0%, transparent 48%),
// // // //             radial-gradient(130% 120% at 0% 100%, rgba(206,196,232,.75) 0%, transparent 50%),
// // // //             radial-gradient(130% 120% at 100% 100%, rgba(196,206,232,.7) 0%, transparent 52%),
// // // //             linear-gradient(160deg,#f3ecf6 0%,#f7f2fa 50%,#f2eef8 100%);
// // // //           font-family:"Manrope","Inter",system-ui,-apple-system,Segoe UI,Roboto,Arial,sans-serif;
// // // //           color:var(--ink);
// // // //           overflow:hidden;
// // // //           isolation:isolate;
// // // //         }

// // // //         #offer.hlc-offer::before,
// // // //         #offer.hlc-offer::after{
// // // //           content:"";
// // // //           position:absolute;
// // // //           top:-4%;
// // // //           width:min(340px,32vw);
// // // //           height:min(210px,22vw);
// // // //           background-repeat:no-repeat;
// // // //           background-size:contain;
// // // //           opacity:.5;
// // // //           z-index:0;
// // // //           pointer-events:none;
// // // //           filter:blur(.3px);
// // // //         }
// // // //         #offer.hlc-offer::before{ left:24%;
// // // //           background-image:radial-gradient(closed-side, transparent 60%, transparent 61%); }
// // // //         .hlc-offer__topfade{
// // // //           position:absolute; inset:0 0 auto 0; height:34%;
// // // //           background:linear-gradient(180deg, rgba(255,255,255,.35), transparent);
// // // //           z-index:0; pointer-events:none;
// // // //         }

// // // //         .hlc-offer__inner{
// // // //           position:relative; z-index:2;
// // // //           width:min(1180px,92vw); margin:0 auto;
// // // //         }

// // // //         .hlc-offer__head{ max-width:560px; margin:0 0 clamp(30px,3.6vw,46px); }
// // // //         .hlc-offer__brand{ margin:0 0 14px; font-size:13px; font-weight:800; letter-spacing:.06em; color:var(--ink); text-transform:uppercase; }
// // // //         .hlc-offer__title{
// // // //           margin:0 0 14px;
// // // //           font-family:"Sora","Manrope",sans-serif;
// // // //           font-size:clamp(30px,4.4vw,52px);
// // // //           font-weight:700; line-height:1.08; letter-spacing:-.03em; color:var(--ink);
// // // //         }
// // // //         .hlc-offer__title em{ font-style:normal; color:var(--magenta); }
// // // //         .hlc-offer__sub{ margin:0; max-width:440px; font-size:15px; line-height:1.6; color:var(--muted); }

// // // //         .hlc-offer__row{
// // // //           display:grid; grid-template-columns:repeat(3,minmax(0,1fr));
// // // //           gap:clamp(16px,1.8vw,22px);
// // // //           perspective:1200px;
// // // //         }

// // // //         /* ---------- frosted glass card — highly transparent, premium ---------- */
// // // //         .offer-card{
// // // //           -webkit-appearance:none; appearance:none; margin:0;
// // // //           font:inherit; color:inherit; text-align:left; cursor:pointer;
// // // //           position:relative; isolation:isolate;
// // // //           display:grid; grid-template-columns:minmax(0,1fr) 132px; align-items:center; gap:16px;
// // // //           padding:26px 26px 26px 28px;
// // // //           border-radius:22px;
// // // //           background:linear-gradient(135deg, rgba(255,255,255,.22), rgba(255,255,255,.08));
// // // //           border:1px solid rgba(255,255,255,.55);
// // // //           box-shadow:
// // // //             0 1px 1px rgba(255,255,255,.5) inset,
// // // //             0 1px 30px rgba(255,255,255,.12) inset,
// // // //             0 18px 44px rgba(84,39,87,.10);
// // // //           -webkit-backdrop-filter:blur(8px) saturate(1.25);
// // // //           backdrop-filter:blur(8px) saturate(1.25);
// // // //           overflow:hidden;
// // // //           transform:perspective(900px) rotateX(0deg) rotateY(0deg) translateZ(0);
// // // //           transform-style:preserve-3d;
// // // //           transition:transform .5s var(--ease), box-shadow .5s var(--ease), background .5s var(--ease), border-color .5s var(--ease);
// // // //         }
// // // //         .offer-card::after{
// // // //           content:""; position:absolute; inset:0; border-radius:22px; padding:1px;
// // // //           background:linear-gradient(135deg, rgba(255,255,255,.9), rgba(155,31,108,.35) 40%, transparent 70%);
// // // //           -webkit-mask:linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0);
// // // //           -webkit-mask-composite:xor; mask-composite:exclude;
// // // //           opacity:0; transition:opacity .5s var(--ease); pointer-events:none;
// // // //         }
// // // //         .offer-card:hover{
// // // //           transform:perspective(900px) rotateX(4deg) rotateY(-5deg) translateY(-8px) translateZ(20px);
// // // //           background:linear-gradient(135deg, rgba(255,255,255,.34), rgba(255,255,255,.14));
// // // //           border-color:rgba(255,255,255,.8);
// // // //           box-shadow:
// // // //             0 1px 1px rgba(255,255,255,.6) inset,
// // // //             0 30px 66px rgba(155,31,108,.22);
// // // //         }
// // // //         .offer-card:hover::after{ opacity:1; }
// // // //         .offer-card:focus-visible{ outline:2px solid var(--magenta); outline-offset:3px; }

// // // //         .offer-card__orb{
// // // //           position:absolute; z-index:-1;
// // // //           right:6%; top:50%; transform:translateY(-50%);
// // // //           width:180px; height:180px; border-radius:50%;
// // // //           filter:blur(38px); opacity:.6;
// // // //           transition:opacity .5s var(--ease), transform .5s var(--ease);
// // // //         }
// // // //         .offer-card__orb--2{
// // // //           left:14%; right:auto; top:64%;
// // // //           width:130px; height:130px; filter:blur(42px); opacity:.4;
// // // //         }
// // // //         .offer-card:hover .offer-card__orb{ opacity:.85; transform:translateY(-50%) scale(1.12); }

// // // //         .offer-card__icon{
// // // //           display:grid; place-items:center; width:36px; height:36px; margin-bottom:16px;
// // // //           border-radius:50%;
// // // //           background:rgba(255,255,255,.5); color:var(--magenta);
// // // //           -webkit-backdrop-filter:blur(6px); backdrop-filter:blur(6px);
// // // //           transition:background .4s var(--ease), color .4s var(--ease);
// // // //         }
// // // //         .offer-card:hover .offer-card__icon{ background:var(--magenta); color:#fff; }

// // // //         .offer-card__title{ margin:0 0 7px; font-size:17px; font-weight:800; line-height:1.22; letter-spacing:-.01em; color:var(--ink); }
// // // //         .offer-card__text{
// // // //           margin:0 0 16px; font-size:13px; line-height:1.5; color:var(--muted);
// // // //           display:-webkit-box; -webkit-line-clamp:2; -webkit-box-orient:vertical; overflow:hidden;
// // // //         }
// // // //         .offer-card__cta{
// // // //           display:inline-flex; align-items:center; gap:8px;
// // // //           font-size:11px; font-weight:800; letter-spacing:.16em; text-transform:uppercase; color:var(--magenta);
// // // //         }
// // // //         .offer-card__cta i{ font-style:normal; transition:transform .4s var(--ease); }
// // // //         .offer-card:hover .offer-card__cta i{ transform:translateX(5px); }

// // // //         /* ---------- product plate ----------
// // // //            Source photography sits on flat white backgrounds. Rather than
// // // //            fight that with a hard drop-shadow (which reads as "cut-out PNG
// // // //            pasted on glass"), the plate itself is lifted to a soft, mostly
// // // //            opaque frosted white so the photo's own white background melts
// // // //            into it, then mix-blend-mode:multiply drops the white further so
// // // //            only the product + its natural shadow remain visible. */
// // // //         .offer-card__plate{
// // // //           position:relative; width:132px; height:132px; border-radius:16px;
// // // //           display:grid; place-items:center;
// // // //           background:linear-gradient(150deg, rgba(255,255,255,.92), rgba(255,255,255,.72));
// // // //           border:1px solid rgba(255,255,255,.75);
// // // //           box-shadow:0 1px 1px rgba(255,255,255,.6) inset, 0 8px 22px rgba(84,39,87,.12);
// // // //           -webkit-backdrop-filter:blur(6px); backdrop-filter:blur(6px);
// // // //           overflow:hidden;
// // // //           transition:transform .5s var(--ease), box-shadow .5s var(--ease);
// // // //         }
// // // //         .offer-card:hover .offer-card__plate{ transform:translateZ(30px) scale(1.04); box-shadow:0 16px 34px rgba(84,39,87,.2); }
// // // //         .offer-card__plate img{
// // // //           width:88%; height:88%; object-fit:contain;
// // // //           mix-blend-mode:multiply;
// // // //           transition:transform .5s var(--ease);
// // // //         }
// // // //         .offer-card:hover .offer-card__plate img{ transform:scale(1.08); }

// // // //         .hlc-offer__empty{ padding:40px 0; font-size:15px; color:var(--muted); }

// // // //         /* ---------- responsive ---------- */
// // // //         @media (max-width:1040px){ .hlc-offer__row{ grid-template-columns:repeat(2,minmax(0,1fr)); } }
// // // //         @media (max-width:600px){
// // // //           .hlc-offer__row{ grid-template-columns:1fr; }
// // // //           .offer-card{ grid-template-columns:minmax(0,1fr) 108px; padding:20px; }
// // // //           .offer-card__plate{ width:108px; height:108px; }
// // // //           .offer-card__orb{ width:140px; height:140px; }
// // // //           .offer-card:hover{ transform:translateY(-6px); }
// // // //         }
// // // //         @media (prefers-reduced-motion:reduce){
// // // //           .offer-card, .offer-card__plate, .offer-card__plate img, .offer-card__icon, .offer-card__cta i, .offer-card__orb{ transition:none; }
// // // //           .offer-card, .offer-card:hover{ transform:none; }
// // // //           .offer-card:hover .offer-card__plate{ transform:none; }
// // // //           .offer-card:hover .offer-card__plate img{ transform:none; }
// // // //         }
// // // //       `}</style>

// // // //       <section id="offer" className="hlc-offer" aria-labelledby="offer-title">
// // // //         <div className="hlc-offer__topfade" />
// // // //         <div className="hlc-offer__inner">
// // // //           <header className="hlc-offer__head">
// // // //             {/* <p className="hlc-offer__brand">HLC</p> */}
// // // //             <h2 id="offer-title" className="hlc-offer__title">
// // // //               Every space needs a <em>different</em> light.
// // // //             </h2>
// // // //             <p className="hlc-offer__sub">
// // // //               Six product families covering homes, offices, retail floors and
// // // //               outdoor sites. Pick a family to see the full range.
// // // //             </p>
// // // //           </header>

// // // //           {CATEGORIES.length === 0 ? (
// // // //             <p className="hlc-offer__empty">No categories available right now.</p>
// // // //           ) : (
// // // //             <div className="hlc-offer__row">
// // // //               {CATEGORIES.map((category, i) => (
// // // //                 <motion.button
// // // //                   key={category.id}
// // // //                   type="button"
// // // //                   className="offer-card"
// // // //                   onClick={() => handleNavigate(category)}
// // // //                   aria-label={`Explore ${category.title}`}
// // // //                   custom={i}
// // // //                   variants={cardMotion}
// // // //                   initial="hidden"
// // // //                   whileInView="show"
// // // //                   viewport={{ once: true, amount: 0.2 }}
// // // //                 >
// // // //                   <span className="offer-card__orb" style={{ background: ORB[i % ORB.length] }} />
// // // //                   <span className="offer-card__orb offer-card__orb--2" style={{ background: ORB[(i + 3) % ORB.length] }} />
// // // //                   <span>
// // // //                     <span className="offer-card__icon"><Icon name={category.icon} /></span>
// // // //                     <h3 className="offer-card__title">{category.title}</h3>
// // // //                     <p className="offer-card__text">{category.description}</p>
// // // //                     <span className="offer-card__cta">Explore <i aria-hidden="true">→</i></span>
// // // //                   </span>
// // // //                   <span className="offer-card__plate">
// // // //                     {category.image && (
// // // //                       <img src={category.image} alt="" loading="lazy" decoding="async" />
// // // //                     )}
// // // //                   </span>
// // // //                 </motion.button>
// // // //               ))}
// // // //             </div>
// // // //           )}
// // // //         </div>
// // // //       </section>
// // // //     </>
// // // //   );
// // // //   };

// // // // export default OfferSection;

// // // import React from "react";
// // // import { useNavigate } from "react-router-dom";
// // // import { motion } from "framer-motion";
// // // import LedBulbImg from "../assets/products/3.png";
// // // import DownlightImg from "../assets/products/9.png";
// // // import PanelImg from "../assets/products/28.png";
// // // import FloodImg from "../assets/products/flood-street.png";
// // // import RopeImg from "../assets/products/rope-light.png";
// // // import BattenImg from "../assets/products/batten.png";

// // // /* ---------- small line icons, one per family ---------- */
// // // const Icon = ({ name }) => {
// // //   const common = {
// // //     width: 18,
// // //     height: 18,
// // //     viewBox: "0 0 24 24",
// // //     fill: "none",
// // //     stroke: "currentColor",
// // //     strokeWidth: 1.8,
// // //     strokeLinecap: "round",
// // //     strokeLinejoin: "round",
// // //     "aria-hidden": "true",
// // //   };
// // //   switch (name) {
// // //     case "bulb":
// // //       return (<svg {...common}><path d="M9 18h6M10 21h4M12 3a6 6 0 0 0-3.5 10.9c.5.4.8 1 .8 1.6V16h5.4v-.5c0-.6.3-1.2.8-1.6A6 6 0 0 0 12 3Z" /></svg>);
// // //     case "downlight":
// // //       return (<svg {...common}><circle cx="12" cy="9" r="5" /><path d="M6 20h12M8.5 16.5 7 20M15.5 16.5 17 20" /></svg>);
// // //     case "tube":
// // //       return (<svg {...common}><rect x="3" y="9" width="18" height="6" rx="3" /><path d="M7 12h10" /></svg>);
// // //     case "panel":
// // //       return (<svg {...common}><rect x="4" y="4" width="16" height="16" rx="2" /><path d="M9 9h6v6H9z" /></svg>);
// // //     case "flood":
// // //       return (<svg {...common}><rect x="4" y="5" width="12" height="9" rx="1.5" /><path d="M16 8.5h4M10 14v5M7 19h6" /></svg>);
// // //     default:
// // //       return (<svg {...common}><circle cx="7" cy="9" r="2" /><circle cx="14" cy="15" r="2" /><circle cx="18" cy="7" r="2" /></svg>);
// // //   }
// // // };

// // // /* ================= STATIC LOCAL CATEGORIES =================
// // //    `dbCategory` must match the real `products.category` value in MySQL exactly. */
// // // const CATEGORIES = [
// // //   { id: "led-bulbs", title: "LED Bulb Series", dbCategory: "LED BULB SERIES", description: "Reliable, efficient bulbs for every home and office.", image: LedBulbImg, icon: "bulb", subcategories: [] },
// // //   { id: "downlights", title: "Downlights & COB", dbCategory: "DOWNLIGHT SERIES", description: "Sleek COB and SMD downlights for modern interiors.", image: DownlightImg, icon: "downlight", subcategories: [] },
// // //   { id: "batten-tube", title: "Batten & Tube Series", dbCategory: "BATTEN AND LED TUBE SERIES", description: "Durable, bright tube lights and battens for all spaces.", image: BattenImg, icon: "tube", subcategories: [] },
// // //   { id: "panel-lights", title: "Panel & Ceiling Lights", dbCategory: "PANEL LIGHT SERIES", description: "Modern panels for a clean, even ceiling finish.", image: PanelImg, icon: "panel", subcategories: [] },
// // //   { id: "flood-outdoor", title: "Flood & Outdoor", dbCategory: "STREET AND FLOOD LIGHT SERIES", description: "High-output flood and street lighting built for weather.", image: FloodImg, icon: "flood", subcategories: [] },
// // //   { id: "rope-decorative", title: "Rope & Decorative", dbCategory: "ROPE LIGHT SERIES", description: "Rope and strip lighting for accent and ambience.", image: RopeImg, icon: "rope", subcategories: [] },
// // // ];

// // // const cardMotion = {
// // //   hidden: { opacity: 0, y: 18 },
// // //   show: (i) => ({ opacity: 1, y: 0, transition: { duration: 0.55, delay: i * 0.06, ease: [0.16, 1, 0.3, 1] } }),
// // // };

// // // /* glow-orb tint per card, cycling the reference's pink→lilac→blue palette */
// // // const ORB = ["#f4a9c4", "#e6a9d6", "#c9b3e8", "#f0aecb", "#d3b0e6", "#b9c2ec"];

// // // const OfferSection = () => {
// // //   const navigate = useNavigate();
// // //   const handleNavigate = (category) => {
// // //     navigate("/product-by-categories", {
// // //       state: { category: category.dbCategory, subcategories: category.subcategories || [] },
// // //     });
// // //   };

// // //   return (
// // //     <>
// // //       <style>{`
// // //         #offer.hlc-offer{
// // //           --magenta:#9b1f6c;
// // //           --plum:#542757;
// // //           --ink:#191825;
// // //           --muted:#6b6880;
// // //           --ease:cubic-bezier(.16,1,.3,1);
// // //           position:relative;
// // //           width:100%;
// // //           padding:clamp(56px,7.5vw,100px) 0 clamp(64px,8vw,110px);
// // //           background:
// // //             radial-gradient(120% 120% at 6% 0%, rgba(244,196,206,.9) 0%, transparent 46%),
// // //             radial-gradient(120% 120% at 100% 2%, rgba(224,186,224,.85) 0%, transparent 48%),
// // //             radial-gradient(130% 120% at 0% 100%, rgba(206,196,232,.8) 0%, transparent 50%),
// // //             radial-gradient(130% 120% at 100% 100%, rgba(196,206,232,.75) 0%, transparent 52%),
// // //             linear-gradient(160deg,#f2ecf6 0%,#f8f4fb 50%,#f1edf9 100%);
// // //           font-family:"Manrope","Inter",system-ui,-apple-system,Segoe UI,Roboto,Arial,sans-serif;
// // //           color:var(--ink);
// // //           overflow:hidden;
// // //           isolation:isolate;
// // //         }

// // //         /* decorative floating acrylic panes — abstract stand-ins for the
// // //            reference's product-holding glass slabs, built from CSS only */
// // //         .hlc-offer__pane{
// // //           position:absolute; z-index:0; pointer-events:none;
// // //           border-radius:18px;
// // //           background:linear-gradient(135deg, rgba(255,255,255,.55), rgba(255,255,255,.12));
// // //           border:1px solid rgba(255,255,255,.65);
// // //           box-shadow:0 30px 60px rgba(84,39,87,.14), 0 1px 1px rgba(255,255,255,.6) inset;
// // //           -webkit-backdrop-filter:blur(4px); backdrop-filter:blur(4px);
// // //         }
// // //         .hlc-offer__pane--1{ width:260px; height:150px; top:-2%; right:20%; transform:rotate(-9deg); opacity:.8; }
// // //         .hlc-offer__pane--2{ width:300px; height:170px; top:4%; right:-4%; transform:rotate(-6deg); opacity:.7; }
// // //         @media (max-width:900px){ .hlc-offer__pane{ display:none; } }

// // //         .hlc-offer__inner{
// // //           position:relative; z-index:2;
// // //           width:min(1180px,92vw); margin:0 auto;
// // //         }

// // //         .hlc-offer__head{ max-width:560px; margin:0 0 clamp(34px,4vw,50px); }
// // //         .hlc-offer__brand{ margin:0 0 12px; font-size:13px; font-weight:800; letter-spacing:.06em; color:var(--ink); text-transform:uppercase; }
// // //         .hlc-offer__title{
// // //           margin:0 0 14px;
// // //           font-family:"Sora","Manrope",sans-serif;
// // //           font-size:clamp(30px,4.4vw,50px);
// // //           font-weight:800; line-height:1.1; letter-spacing:-.03em; color:var(--ink);
// // //         }
// // //         .hlc-offer__sub{ margin:0; max-width:440px; font-size:15px; line-height:1.6; color:var(--muted); }

// // //         .hlc-offer__row{
// // //           display:grid; grid-template-columns:repeat(3,minmax(0,1fr));
// // //           gap:clamp(20px,2.2vw,30px);
// // //           perspective:1200px;
// // //         }

// // //         /* ---------- TRUE glass card ----------
// // //            Almost no fill — the page's gradient and orbs must read
// // //            straight through. overflow:visible is required so the
// // //            product photo can break past the card's own edge. */
// // //         .offer-card{
// // //           -webkit-appearance:none; appearance:none; margin:0;
// // //           font:inherit; color:inherit; text-align:left; cursor:pointer;
// // //           position:relative; isolation:isolate; display:block;
// // //           padding:28px 22px 24px 26px;
// // //           border-radius:20px;
// // //           background:linear-gradient(135deg, rgba(255,255,255,.16), rgba(255,255,255,.04));
// // //           border:1px solid rgba(255,255,255,.55);
// // //           box-shadow:
// // //             0 1px 1px rgba(255,255,255,.5) inset,
// // //             0 16px 40px rgba(84,39,87,.08);
// // //           -webkit-backdrop-filter:blur(10px) saturate(1.3);
// // //           backdrop-filter:blur(10px) saturate(1.3);
// // //           overflow:visible;
// // //           transform:perspective(900px) rotateX(0deg) rotateY(0deg) translateZ(0);
// // //           transform-style:preserve-3d;
// // //           transition:transform .5s var(--ease), box-shadow .5s var(--ease), background .5s var(--ease), border-color .5s var(--ease);
// // //         }
// // //         .offer-card::after{
// // //           content:""; position:absolute; inset:0; border-radius:20px; padding:1px;
// // //           background:linear-gradient(135deg, rgba(255,255,255,.95), rgba(155,31,108,.4) 42%, transparent 72%);
// // //           -webkit-mask:linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0);
// // //           -webkit-mask-composite:xor; mask-composite:exclude;
// // //           opacity:0; transition:opacity .5s var(--ease); pointer-events:none;
// // //         }
// // //         .offer-card:hover{
// // //           transform:perspective(900px) rotateX(4deg) rotateY(-5deg) translateY(-8px) translateZ(20px);
// // //           background:linear-gradient(135deg, rgba(255,255,255,.26), rgba(255,255,255,.08));
// // //           border-color:rgba(255,255,255,.85);
// // //           box-shadow:
// // //             0 1px 1px rgba(255,255,255,.6) inset,
// // //             0 30px 60px rgba(155,31,108,.2);
// // //         }
// // //         .offer-card:hover::after{ opacity:1; }
// // //         .offer-card:focus-visible{ outline:2px solid var(--magenta); outline-offset:3px; }

// // //         .offer-card__orb{
// // //           position:absolute; z-index:-1;
// // //           right:8%; top:38%; transform:translateY(-50%);
// // //           width:170px; height:170px; border-radius:50%;
// // //           filter:blur(40px); opacity:.65;
// // //           transition:opacity .5s var(--ease), transform .5s var(--ease);
// // //         }
// // //         .offer-card__orb--2{
// // //           left:10%; right:auto; top:78%;
// // //           width:120px; height:120px; filter:blur(40px); opacity:.4;
// // //         }
// // //         .offer-card:hover .offer-card__orb{ opacity:.9; transform:translateY(-50%) scale(1.12); }

// // //         .offer-card__icon{
// // //           display:grid; place-items:center; width:34px; height:34px; margin-bottom:44px;
// // //           border-radius:50%;
// // //           background:rgba(255,255,255,.45); color:var(--magenta);
// // //           -webkit-backdrop-filter:blur(6px); backdrop-filter:blur(6px);
// // //           transition:background .4s var(--ease), color .4s var(--ease);
// // //         }
// // //         .offer-card:hover .offer-card__icon{ background:var(--magenta); color:#fff; }

// // //         .offer-card__body{ max-width:60%; position:relative; z-index:2; }
// // //         .offer-card__title{ margin:0 0 7px; font-size:17px; font-weight:800; line-height:1.22; letter-spacing:-.01em; color:var(--ink); }
// // //         .offer-card__text{
// // //           margin:0 0 18px; font-size:13px; line-height:1.5; color:var(--muted);
// // //           display:-webkit-box; -webkit-line-clamp:2; -webkit-box-orient:vertical; overflow:hidden;
// // //         }
// // //         .offer-card__cta{
// // //           display:inline-flex; align-items:center; gap:8px;
// // //           font-size:11px; font-weight:800; letter-spacing:.16em; text-transform:uppercase; color:var(--magenta);
// // //         }
// // //         .offer-card__cta i{ font-style:normal; transition:transform .4s var(--ease); }
// // //         .offer-card:hover .offer-card__cta i{ transform:translateX(5px); }

// // //         /* ---------- floating product photo ----------
// // //            No boxed tile — the image itself breaks past the card's
// // //            top-right corner, the signature move of the reference.
// // //            mix-blend-mode:multiply drops the photo's white studio
// // //            background so only the fixture + its own shadow remain. */
// // //         .offer-card__plate{
// // //           position:absolute; z-index:3;
// // //           top:-16px; right:-16px;
// // //           width:128px; height:128px;
// // //           pointer-events:none;
// // //           transition:transform .5s var(--ease), filter .5s var(--ease);
// // //         }
// // //         .offer-card:hover .offer-card__plate{ transform:translate(4px,-4px) scale(1.06) rotate(2deg); }
// // //         .offer-card__plate img{
// // //           width:100%; height:100%; object-fit:contain;
// // //           mix-blend-mode:multiply;
// // //           filter:drop-shadow(0 18px 22px rgba(84,39,87,.22));
// // //         }

// // //         .hlc-offer__empty{ padding:40px 0; font-size:15px; color:var(--muted); }

// // //         /* ---------- responsive ---------- */
// // //         @media (max-width:1040px){ .hlc-offer__row{ grid-template-columns:repeat(2,minmax(0,1fr)); } }
// // //         @media (max-width:600px){
// // //           .hlc-offer__row{ grid-template-columns:1fr; }
// // //           .offer-card{ padding:24px 20px 22px 22px; }
// // //           .offer-card__body{ max-width:64%; }
// // //           .offer-card__plate{ width:100px; height:100px; top:-12px; right:-12px; }
// // //           .offer-card__orb{ width:130px; height:130px; }
// // //           .offer-card:hover{ transform:translateY(-6px); }
// // //         }
// // //         @media (prefers-reduced-motion:reduce){
// // //           .offer-card, .offer-card__plate, .offer-card__icon, .offer-card__cta i, .offer-card__orb{ transition:none; }
// // //           .offer-card, .offer-card:hover{ transform:none; }
// // //           .offer-card:hover .offer-card__plate{ transform:none; }
// // //         }
// // //       `}</style>

// // //       <section id="offer" className="hlc-offer" aria-labelledby="offer-title">
// // //         <span className="hlc-offer__pane hlc-offer__pane--1" aria-hidden="true" />
// // //         <span className="hlc-offer__pane hlc-offer__pane--2" aria-hidden="true" />
// // //         <div className="hlc-offer__inner">
// // //           <header className="hlc-offer__head">
// // //             <p className="hlc-offer__brand">HLC</p>
// // //             <h2 id="offer-title" className="hlc-offer__title">
// // //               Every space needs a different light.
// // //             </h2>
// // //             <p className="hlc-offer__sub">
// // //               Six product families covering homes, offices, retail floors and
// // //               outdoor sites. Pick a family to see the full range.
// // //             </p>
// // //           </header>

// // //           {CATEGORIES.length === 0 ? (
// // //             <p className="hlc-offer__empty">No categories available right now.</p>
// // //           ) : (
// // //             <div className="hlc-offer__row">
// // //               {CATEGORIES.map((category, i) => (
// // //                 <motion.button
// // //                   key={category.id}
// // //                   type="button"
// // //                   className="offer-card"
// // //                   onClick={() => handleNavigate(category)}
// // //                   aria-label={`Explore ${category.title}`}
// // //                   custom={i}
// // //                   variants={cardMotion}
// // //                   initial="hidden"
// // //                   whileInView="show"
// // //                   viewport={{ once: true, amount: 0.2 }}
// // //                 >
// // //                   <span className="offer-card__orb" style={{ background: ORB[i % ORB.length] }} />
// // //                   <span className="offer-card__orb offer-card__orb--2" style={{ background: ORB[(i + 3) % ORB.length] }} />
// // //                   <span className="offer-card__plate">
// // //                     {category.image && (
// // //                       <img src={category.image} alt="" loading="lazy" decoding="async" />
// // //                     )}
// // //                   </span>
// // //                   <span className="offer-card__body">
// // //                     <span className="offer-card__icon"><Icon name={category.icon} /></span>
// // //                     <h3 className="offer-card__title">{category.title}</h3>
// // //                     <p className="offer-card__text">{category.description}</p>
// // //                     <span className="offer-card__cta">Explore <i aria-hidden="true">→</i></span>
// // //                   </span>
// // //                 </motion.button>
// // //               ))}
// // //             </div>
// // //           )}
// // //         </div>
// // //       </section>
// // //     </>
// // //   );
// // // };

// // // export default OfferSection;


// // // import React from "react";
// // // import { useNavigate } from "react-router-dom";
// // // import { motion } from "framer-motion";
// // // import LedBulbImg from "../assets/products/bulb.png";
// // // import DownlightImg from "../assets/products/downlights.png";
// // // import PanelImg from "../assets/products/panels.png";
// // // import FloodImg from "../assets/products/flood-street.png";
// // // import RopeImg from "../assets/products/rope-light.png";
// // // import BattenImg from "../assets/products/batten.png";

// // // /* ---------- small line icons, one per family ---------- */
// // // const Icon = ({ name }) => {
// // //   const common = {
// // //     width: 18,
// // //     height: 18,
// // //     viewBox: "0 0 24 24",
// // //     fill: "none",
// // //     stroke: "currentColor",
// // //     strokeWidth: 1.8,
// // //     strokeLinecap: "round",
// // //     strokeLinejoin: "round",
// // //     "aria-hidden": "true",
// // //   };
// // //   switch (name) {
// // //     case "bulb":
// // //       return (<svg {...common}><path d="M9 18h6M10 21h4M12 3a6 6 0 0 0-3.5 10.9c.5.4.8 1 .8 1.6V16h5.4v-.5c0-.6.3-1.2.8-1.6A6 6 0 0 0 12 3Z" /></svg>);
// // //     case "downlight":
// // //       return (<svg {...common}><circle cx="12" cy="9" r="5" /><path d="M6 20h12M8.5 16.5 7 20M15.5 16.5 17 20" /></svg>);
// // //     case "tube":
// // //       return (<svg {...common}><rect x="3" y="9" width="18" height="6" rx="3" /><path d="M7 12h10" /></svg>);
// // //     case "panel":
// // //       return (<svg {...common}><rect x="4" y="4" width="16" height="16" rx="2" /><path d="M9 9h6v6H9z" /></svg>);
// // //     case "flood":
// // //       return (<svg {...common}><rect x="4" y="5" width="12" height="9" rx="1.5" /><path d="M16 8.5h4M10 14v5M7 19h6" /></svg>);
// // //     default:
// // //       return (<svg {...common}><circle cx="7" cy="9" r="2" /><circle cx="14" cy="15" r="2" /><circle cx="18" cy="7" r="2" /></svg>);
// // //   }
// // // };

// // // /* ================= STATIC LOCAL CATEGORIES =================
// // //    `dbCategory` must match the real `products.category` value in MySQL exactly. */
// // // const CATEGORIES = [
// // //   { id: "led-bulbs", title: "LED Bulb Series", dbCategory: "LED BULB SERIES", description: "Reliable, efficient bulbs for every home and office.", image: LedBulbImg, icon: "bulb", subcategories: [] },
// // //   { id: "downlights", title: "Downlights & COB", dbCategory: "DOWNLIGHT SERIES", description: "Sleek COB and SMD downlights for modern interiors.", image: DownlightImg, icon: "downlight", subcategories: [] },
// // //   { id: "batten-tube", title: "Batten & Tube Series", dbCategory: "BATTEN AND LED TUBE SERIES", description: "Durable, bright tube lights and battens for all spaces.", image: BattenImg, icon: "tube", subcategories: [] },
// // //   { id: "panel-lights", title: "Panel & Ceiling Lights", dbCategory: "PANEL LIGHT SERIES", description: "Modern panels for a clean, even ceiling finish.", image: PanelImg, icon: "panel", subcategories: [] },
// // //   { id: "flood-outdoor", title: "Flood & Outdoor", dbCategory: "STREET AND FLOOD LIGHT SERIES", description: "High-output flood and street lighting built for weather.", image: FloodImg, icon: "flood", subcategories: [] },
// // //   { id: "rope-decorative", title: "Rope & Decorative", dbCategory: "ROPE LIGHT SERIES", description: "Rope and strip lighting for accent and ambience.", image: RopeImg, icon: "rope", subcategories: [] },
// // // ];

// // // const cardMotion = {
// // //   hidden: { opacity: 0, y: 18 },
// // //   show: (i) => ({ opacity: 1, y: 0, transition: { duration: 0.55, delay: i * 0.06, ease: [0.16, 1, 0.3, 1] } }),
// // // };

// // // /* glow-orb tint per card, cycling the reference's pink→lilac→blue palette */
// // // const ORB = ["#f4a9c4", "#e6a9d6", "#c9b3e8", "#f0aecb", "#d3b0e6", "#b9c2ec"];

// // // const OfferSection = () => {
// // //   const navigate = useNavigate();
// // //   const handleNavigate = (category) => {
// // //     navigate("/product-by-categories", {
// // //       state: { category: category.dbCategory, subcategories: category.subcategories || [] },
// // //     });
// // //   };

// // //   return (
// // //     <>
// // //       <style>{`
// // //         #offer.hlc-offer{
// // //           --magenta:#9b1f6c;
// // //           --plum:#542757;
// // //           --ink:#191825;
// // //           --muted:#6b6880;
// // //           --ease:cubic-bezier(.16,1,.3,1);
// // //           position:relative;
// // //           width:100%;
// // //           padding:clamp(56px,7.5vw,100px) 0 clamp(64px,8vw,110px);
// // //           background:
// // //             radial-gradient(120% 120% at 6% 0%, rgba(244,196,206,.9) 0%, transparent 46%),
// // //             radial-gradient(120% 120% at 100% 2%, rgba(224,186,224,.85) 0%, transparent 48%),
// // //             radial-gradient(130% 120% at 0% 100%, rgba(206,196,232,.8) 0%, transparent 50%),
// // //             radial-gradient(130% 120% at 100% 100%, rgba(196,206,232,.75) 0%, transparent 52%),
// // //             linear-gradient(160deg,#f2ecf6 0%,#f8f4fb 50%,#f1edf9 100%);
// // //           font-family:"Manrope","Inter",system-ui,-apple-system,Segoe UI,Roboto,Arial,sans-serif;
// // //           color:var(--ink);
// // //           overflow:hidden;
// // //           isolation:isolate;
// // //         }

// // //         .hlc-offer__pane{
// // //           position:absolute; z-index:0; pointer-events:none;
// // //           border-radius:18px;
// // //           background:linear-gradient(135deg, rgba(255,255,255,.55), rgba(255,255,255,.12));
// // //           border:1px solid rgba(255,255,255,.65);
// // //           box-shadow:0 30px 60px rgba(84,39,87,.14), 0 1px 1px rgba(255,255,255,.6) inset;
// // //           -webkit-backdrop-filter:blur(4px); backdrop-filter:blur(4px);
// // //         }
// // //         .hlc-offer__pane--1{ width:260px; height:150px; top:-2%; right:20%; transform:rotate(-9deg); opacity:.8; }
// // //         .hlc-offer__pane--2{ width:300px; height:170px; top:4%; right:-4%; transform:rotate(-6deg); opacity:.7; }
// // //         @media (max-width:900px){ .hlc-offer__pane{ display:none; } }

// // //         .hlc-offer__inner{
// // //           position:relative; z-index:2;
// // //           width:min(1180px,92vw); margin:0 auto;
// // //         }

// // //         .hlc-offer__head{ max-width:560px; margin:0 0 clamp(34px,4vw,50px); }
// // //         .hlc-offer__brand{ margin:0 0 12px; font-size:13px; font-weight:800; letter-spacing:.06em; color:var(--ink); text-transform:uppercase; }
// // //         .hlc-offer__title{
// // //           margin:0 0 14px;
// // //           font-family:"Sora","Manrope",sans-serif;
// // //           font-size:clamp(30px,4.4vw,50px);
// // //           font-weight:800; line-height:1.1; letter-spacing:-.03em; color:var(--ink);
// // //         }
// // //         .hlc-offer__sub{ margin:0; max-width:440px; font-size:15px; line-height:1.6; color:var(--muted); }

// // //         .hlc-offer__row{
// // //           display:grid; grid-template-columns:repeat(3,minmax(0,1fr));
// // //           gap:clamp(20px,2.2vw,30px);
// // //           perspective:1200px;
// // //         }

// // //         /* ---------- glass card ----------
// // //            Transparent enough that the page's gradient and orbs read
// // //            through, but the product tile now lives INSIDE the card's
// // //            bounds — large and fully visible, not clipped by any edge. */
// // //         .offer-card{
// // //           -webkit-appearance:none; appearance:none; margin:0;
// // //           font:inherit; color:inherit; text-align:left; cursor:pointer;
// // //           position:relative; isolation:isolate;
// // //           display:flex; flex-direction:column; gap:18px;
// // //           padding:24px 24px 22px;
// // //           border-radius:20px;
// // //           background:linear-gradient(135deg, rgba(255,255,255,.2), rgba(255,255,255,.06));
// // //           border:1px solid rgba(255,255,255,.55);
// // //           box-shadow:
// // //             0 1px 1px rgba(255,255,255,.5) inset,
// // //             0 16px 40px rgba(84,39,87,.08);
// // //           -webkit-backdrop-filter:blur(10px) saturate(1.3);
// // //           backdrop-filter:blur(10px) saturate(1.3);
// // //           overflow:hidden;
// // //           transform:perspective(900px) rotateX(0deg) rotateY(0deg) translateZ(0);
// // //           transform-style:preserve-3d;
// // //           transition:transform .5s var(--ease), box-shadow .5s var(--ease), background .5s var(--ease), border-color .5s var(--ease);
// // //         }
// // //         .offer-card::after{
// // //           content:""; position:absolute; inset:0; border-radius:20px; padding:1px;
// // //           background:linear-gradient(135deg, rgba(255,255,255,.95), rgba(155,31,108,.4) 42%, transparent 72%);
// // //           -webkit-mask:linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0);
// // //           -webkit-mask-composite:xor; mask-composite:exclude;
// // //           opacity:0; transition:opacity .5s var(--ease); pointer-events:none;
// // //         }
// // //         .offer-card:hover{
// // //           transform:perspective(900px) rotateX(3deg) rotateY(-4deg) translateY(-8px) translateZ(20px);
// // //           background:linear-gradient(135deg, rgba(255,255,255,.3), rgba(255,255,255,.1));
// // //           border-color:rgba(255,255,255,.85);
// // //           box-shadow:
// // //             0 1px 1px rgba(255,255,255,.6) inset,
// // //             0 30px 60px rgba(155,31,108,.2);
// // //         }
// // //         .offer-card:hover::after{ opacity:1; }
// // //         .offer-card:focus-visible{ outline:2px solid var(--magenta); outline-offset:3px; }

// // //         .offer-card__orb{
// // //           position:absolute; z-index:-1;
// // //           right:6%; top:30%; transform:translateY(-50%);
// // //           width:170px; height:170px; border-radius:50%;
// // //           filter:blur(40px); opacity:.55;
// // //           transition:opacity .5s var(--ease), transform .5s var(--ease);
// // //         }
// // //         .offer-card__orb--2{
// // //           left:8%; right:auto; top:88%;
// // //           width:120px; height:120px; filter:blur(40px); opacity:.35;
// // //         }
// // //         .offer-card:hover .offer-card__orb{ opacity:.8; transform:translateY(-50%) scale(1.1); }

// // //         /* ---------- product tile — large, contained, unmistakably
// // //            the product. Sits inside the card on its own soft plate so
// // //            it stays crisp and legible over the busy gradient behind it. */
// // //         .offer-card__plate{
// // //           position:relative; z-index:2;
// // //           width:100%; height:168px;
// // //           border-radius:14px;
// // //           display:grid; place-items:center;
// // //           background:linear-gradient(150deg, rgba(255,255,255,.55), rgba(255,255,255,.22));
// // //           border:1px solid rgba(255,255,255,.6);
// // //           box-shadow:0 1px 1px rgba(255,255,255,.5) inset, 0 10px 26px rgba(84,39,87,.10);
// // //           overflow:hidden;
// // //           transition:transform .5s var(--ease), box-shadow .5s var(--ease);
// // //         }
// // //         .offer-card:hover .offer-card__plate{ transform:scale(1.03); box-shadow:0 18px 36px rgba(84,39,87,.18); }
// // //         .offer-card__plate img{
// // //           width:88%; height:88%; object-fit:contain;
// // //           mix-blend-mode:multiply;
// // //           transition:transform .5s var(--ease);
// // //         }
// // //         .offer-card:hover .offer-card__plate img{ transform:scale(1.05); }

// // //         .offer-card__body{ position:relative; z-index:2; }
// // //         .offer-card__head{ display:flex; align-items:center; gap:10px; margin-bottom:10px; }
// // //         .offer-card__icon{
// // //           display:grid; place-items:center; width:30px; height:30px; flex:none;
// // //           border-radius:50%;
// // //           background:rgba(255,255,255,.45); color:var(--magenta);
// // //           transition:background .4s var(--ease), color .4s var(--ease);
// // //         }
// // //         .offer-card:hover .offer-card__icon{ background:var(--magenta); color:#fff; }
// // //         .offer-card__title{ margin:0; font-size:17px; font-weight:800; line-height:1.22; letter-spacing:-.01em; color:var(--ink); }
// // //         .offer-card__text{
// // //           margin:0 0 14px; font-size:13px; line-height:1.5; color:var(--muted);
// // //           display:-webkit-box; -webkit-line-clamp:2; -webkit-box-orient:vertical; overflow:hidden;
// // //         }
// // //         .offer-card__cta{
// // //           display:inline-flex; align-items:center; gap:8px;
// // //           font-size:11px; font-weight:800; letter-spacing:.16em; text-transform:uppercase; color:var(--magenta);
// // //         }
// // //         .offer-card__cta i{ font-style:normal; transition:transform .4s var(--ease); }
// // //         .offer-card:hover .offer-card__cta i{ transform:translateX(5px); }

// // //         .hlc-offer__empty{ padding:40px 0; font-size:15px; color:var(--muted); }

// // //         /* ---------- responsive ---------- */
// // //         @media (max-width:1040px){ .hlc-offer__row{ grid-template-columns:repeat(2,minmax(0,1fr)); } }
// // //         @media (max-width:600px){
// // //           .hlc-offer__row{ grid-template-columns:1fr; }
// // //           .offer-card{ padding:20px; }
// // //           .offer-card__plate{ height:150px; }
// // //           .offer-card__orb{ width:130px; height:130px; }
// // //           .offer-card:hover{ transform:translateY(-6px); }
// // //         }
// // //         @media (prefers-reduced-motion:reduce){
// // //           .offer-card, .offer-card__plate, .offer-card__plate img, .offer-card__icon, .offer-card__cta i, .offer-card__orb{ transition:none; }
// // //           .offer-card, .offer-card:hover{ transform:none; }
// // //           .offer-card:hover .offer-card__plate{ transform:none; }
// // //           .offer-card:hover .offer-card__plate img{ transform:none; }
// // //         }
// // //       `}</style>

// // //       <section id="offer" className="hlc-offer" aria-labelledby="offer-title">
// // //         <span className="hlc-offer__pane hlc-offer__pane--1" aria-hidden="true" />
// // //         <span className="hlc-offer__pane hlc-offer__pane--2" aria-hidden="true" />
// // //         <div className="hlc-offer__inner">
// // //           <header className="hlc-offer__head">
// // //             <p className="hlc-offer__brand">HLC</p>
// // //             <h2 id="offer-title" className="hlc-offer__title">
// // //               Every space needs a different light.
// // //             </h2>
// // //             <p className="hlc-offer__sub">
// // //               Six product families covering homes, offices, retail floors and
// // //               outdoor sites. Pick a family to see the full range.
// // //             </p>
// // //           </header>

// // //           {CATEGORIES.length === 0 ? (
// // //             <p className="hlc-offer__empty">No categories available right now.</p>
// // //           ) : (
// // //             <div className="hlc-offer__row">
// // //               {CATEGORIES.map((category, i) => (
// // //                 <motion.button
// // //                   key={category.id}
// // //                   type="button"
// // //                   className="offer-card"
// // //                   onClick={() => handleNavigate(category)}
// // //                   aria-label={`Explore ${category.title}`}
// // //                   custom={i}
// // //                   variants={cardMotion}
// // //                   initial="hidden"
// // //                   whileInView="show"
// // //                   viewport={{ once: true, amount: 0.2 }}
// // //                 >
// // //                   <span className="offer-card__orb" style={{ background: ORB[i % ORB.length] }} />
// // //                   <span className="offer-card__orb offer-card__orb--2" style={{ background: ORB[(i + 3) % ORB.length] }} />

// // //                   <span className="offer-card__plate">
// // //                     {category.image && (
// // //                       <img src={category.image} alt={category.title} loading="lazy" decoding="async" />
// // //                     )}
// // //                   </span>

// // //                   <span className="offer-card__body">
// // //                     <span className="offer-card__head">
// // //                       <span className="offer-card__icon"><Icon name={category.icon} /></span>
// // //                       <h3 className="offer-card__title">{category.title}</h3>
// // //                     </span>
// // //                     <p className="offer-card__text">{category.description}</p>
// // //                     <span className="offer-card__cta">Explore <i aria-hidden="true">→</i></span>
// // //                   </span>
// // //                 </motion.button>
// // //               ))}
// // //             </div>
// // //           )}
// // //         </div>
// // //       </section>
// // //     </>
// // //   );
// // // };

// // // export default OfferSection;


// // import React, { useRef } from "react";
// // import { useNavigate } from "react-router-dom";
// // import { motion } from "framer-motion";
// // import LedBulbImg from "../assets/products/bulb.png";
// // import DownlightImg from "../assets/products/downlights.png";
// // import PanelImg from "../assets/products/panels.png";
// // import FloodImg from "../assets/products/flood-street.png";
// // import RopeImg from "../assets/products/rope-light.png";
// // import BattenImg from "../assets/products/batten.png";

// // /* ---------- small line icons, one per family ---------- */
// // const Icon = ({ name }) => {
// //   const common = {
// //     width: 18,
// //     height: 18,
// //     viewBox: "0 0 24 24",
// //     fill: "none",
// //     stroke: "currentColor",
// //     strokeWidth: 1.8,
// //     strokeLinecap: "round",
// //     strokeLinejoin: "round",
// //     "aria-hidden": "true",
// //   };
// //   switch (name) {
// //     case "bulb":
// //       return (<svg {...common}><path d="M9 18h6M10 21h4M12 3a6 6 0 0 0-3.5 10.9c.5.4.8 1 .8 1.6V16h5.4v-.5c0-.6.3-1.2.8-1.6A6 6 0 0 0 12 3Z" /></svg>);
// //     case "downlight":
// //       return (<svg {...common}><circle cx="12" cy="9" r="5" /><path d="M6 20h12M8.5 16.5 7 20M15.5 16.5 17 20" /></svg>);
// //     case "tube":
// //       return (<svg {...common}><rect x="3" y="9" width="18" height="6" rx="3" /><path d="M7 12h10" /></svg>);
// //     case "panel":
// //       return (<svg {...common}><rect x="4" y="4" width="16" height="16" rx="2" /><path d="M9 9h6v6H9z" /></svg>);
// //     case "flood":
// //       return (<svg {...common}><rect x="4" y="5" width="12" height="9" rx="1.5" /><path d="M16 8.5h4M10 14v5M7 19h6" /></svg>);
// //     default:
// //       return (<svg {...common}><circle cx="7" cy="9" r="2" /><circle cx="14" cy="15" r="2" /><circle cx="18" cy="7" r="2" /></svg>);
// //   }
// // };

// // /* ================= STATIC LOCAL CATEGORIES =================
// //    `dbCategory` must match the real `products.category` value in MySQL exactly. */
// // const CATEGORIES = [
// //   { id: "led-bulbs", title: "LED Bulb Series", dbCategory: "LED BULB SERIES", description: "Reliable, efficient bulbs for every home and office.", image: LedBulbImg, icon: "bulb", subcategories: [] },
// //   { id: "downlights", title: "Downlights & COB", dbCategory: "DOWNLIGHT SERIES", description: "Sleek COB and SMD downlights for modern interiors.", image: DownlightImg, icon: "downlight", subcategories: [] },
// //   { id: "batten-tube", title: "Batten & Tube Series", dbCategory: "BATTEN AND LED TUBE SERIES", description: "Durable, bright tube lights and battens for all spaces.", image: BattenImg, icon: "tube", subcategories: [] },
// //   { id: "panel-lights", title: "Panel & Ceiling Lights", dbCategory: "PANEL LIGHT SERIES", description: "Modern panels for a clean, even ceiling finish.", image: PanelImg, icon: "panel", subcategories: [] },
// //   { id: "flood-outdoor", title: "Flood & Outdoor", dbCategory: "STREET AND FLOOD LIGHT SERIES", description: "High-output flood and street lighting built for weather.", image: FloodImg, icon: "flood", subcategories: [] },
// //   { id: "rope-decorative", title: "Rope & Decorative", dbCategory: "ROPE LIGHT SERIES", description: "Rope and strip lighting for accent and ambience.", image: RopeImg, icon: "rope", subcategories: [] },
// // ];

// // const cardMotion = {
// //   hidden: { opacity: 0, y: 18 },
// //   show: (i) => ({ opacity: 1, y: 0, transition: { duration: 0.55, delay: i * 0.06, ease: [0.16, 1, 0.3, 1] } }),
// // };

// // /* glow-orb tint per card, cycling the reference's pink→lilac→blue palette */
// // const ORB = ["#f4a9c4", "#e6a9d6", "#c9b3e8", "#f0aecb", "#d3b0e6", "#b9c2ec"];

// // const OfferSection = () => {
// //   const navigate = useNavigate();
// //   const handleNavigate = (category) => {
// //     navigate("/product-by-categories", {
// //       state: { category: category.dbCategory, subcategories: category.subcategories || [] },
// //     });
// //   };

// //   /* ---- dynamic cursor-following 3D tilt ----
// //      tilts each card toward the pointer; resets smoothly on leave.
// //      Respects reduced-motion and skips on touch (no hover). */
// //   const reduced = typeof window !== "undefined"
// //     && window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

// //   const handleTilt = (e) => {
// //     if (reduced) return;
// //     const card = e.currentTarget;
// //     const b = card.getBoundingClientRect();
// //     const px = (e.clientX - b.left) / b.width - 0.5;   // -0.5 .. 0.5
// //     const py = (e.clientY - b.top) / b.height - 0.5;
// //     const MAX = 10; // degrees
// //     const rotY = px * MAX * 2;
// //     const rotX = -py * MAX * 2;
// //     card.style.transform =
// //       `perspective(900px) rotateX(${rotX.toFixed(2)}deg) rotateY(${rotY.toFixed(2)}deg) translateY(-8px) translateZ(24px)`;
// //     // move the glow toward the cursor for extra depth
// //     card.style.setProperty("--mx", `${(px + 0.5) * 100}%`);
// //     card.style.setProperty("--my", `${(py + 0.5) * 100}%`);
// //   };
// //   const resetTilt = (e) => {
// //     const card = e.currentTarget;
// //     card.style.transform = "";
// //   };

// //   return (
// //     <>
// //       <style>{`
// //         #offer.hlc-offer{
// //           --magenta:#9b1f6c;
// //           --plum:#542757;
// //           --ink:#191825;
// //           --muted:#6b6880;
// //           --ease:cubic-bezier(.16,1,.3,1);
// //           position:relative;
// //           width:100%;
// //           padding:clamp(56px,7.5vw,100px) 0 clamp(64px,8vw,110px);
// //           background:
// //             radial-gradient(120% 120% at 6% 0%, rgba(244,196,206,.9) 0%, transparent 46%),
// //             radial-gradient(120% 120% at 100% 2%, rgba(224,186,224,.85) 0%, transparent 48%),
// //             radial-gradient(130% 120% at 0% 100%, rgba(206,196,232,.8) 0%, transparent 50%),
// //             radial-gradient(130% 120% at 100% 100%, rgba(196,206,232,.75) 0%, transparent 52%),
// //             linear-gradient(160deg,#f2ecf6 0%,#f8f4fb 50%,#f1edf9 100%);
// //           font-family:"Manrope","Inter",system-ui,-apple-system,Segoe UI,Roboto,Arial,sans-serif;
// //           color:var(--ink);
// //           overflow:hidden;
// //           isolation:isolate;
// //         }

// //         .hlc-offer__pane{
// //           position:absolute; z-index:0; pointer-events:none;
// //           border-radius:18px;
// //           background:linear-gradient(135deg, rgba(255,255,255,.55), rgba(255,255,255,.12));
// //           border:1px solid rgba(255,255,255,.65);
// //           box-shadow:0 30px 60px rgba(84,39,87,.14), 0 1px 1px rgba(255,255,255,.6) inset;
// //           -webkit-backdrop-filter:blur(4px); backdrop-filter:blur(4px);
// //         }
// //         .hlc-offer__pane--1{ width:260px; height:150px; top:-2%; right:20%; transform:rotate(-9deg); opacity:.8; }
// //         .hlc-offer__pane--2{ width:300px; height:170px; top:4%; right:-4%; transform:rotate(-6deg); opacity:.7; }
// //         @media (max-width:900px){ .hlc-offer__pane{ display:none; } }

// //         .hlc-offer__inner{
// //           position:relative; z-index:2;
// //           width:min(1180px,92vw); margin:0 auto;
// //         }

// //         .hlc-offer__head{ max-width:560px; margin:0 0 clamp(34px,4vw,50px); }
// //         .hlc-offer__brand{ margin:0 0 12px; font-size:13px; font-weight:800; letter-spacing:.06em; color:var(--ink); text-transform:uppercase; }
// //         .hlc-offer__title{
// //           margin:0 0 14px;
// //           font-family:"Sora","Manrope",sans-serif;
// //           font-size:clamp(30px,4.4vw,50px);
// //           font-weight:800; line-height:1.1; letter-spacing:-.03em; color:var(--ink);
// //         }
// //         .hlc-offer__sub{ margin:0; max-width:440px; font-size:15px; line-height:1.6; color:var(--muted); }

// //         .hlc-offer__row{
// //           display:grid; grid-template-columns:repeat(3,minmax(0,1fr));
// //           gap:clamp(20px,2.2vw,30px);
// //           perspective:1200px;
// //         }

// //         /* ---------- glass card ---------- */
// //         .offer-card{
// //           -webkit-appearance:none; appearance:none; margin:0;
// //           font:inherit; color:inherit; text-align:left; cursor:pointer;
// //           position:relative; isolation:isolate;
// //           display:flex; flex-direction:column; gap:18px;
// //           padding:24px 24px 22px;
// //           border-radius:20px;
// //           background:linear-gradient(135deg, rgba(255,255,255,.2), rgba(255,255,255,.06));
// //           border:1px solid rgba(255,255,255,.55);
// //           box-shadow:
// //             0 1px 1px rgba(255,255,255,.5) inset,
// //             0 16px 40px rgba(84,39,87,.08);
// //           -webkit-backdrop-filter:blur(10px) saturate(1.3);
// //           backdrop-filter:blur(10px) saturate(1.3);
// //           overflow:hidden;
// //           transform-style:preserve-3d;
// //           /* fast transform so the tilt tracks the cursor; slower reset via leave */
// //           transition:transform .18s ease-out, box-shadow .5s var(--ease), background .5s var(--ease), border-color .5s var(--ease);
// //         }
// //         /* cursor-following sheen highlight */
// //         .offer-card__sheen{
// //           position:absolute; inset:0; z-index:1; border-radius:20px; pointer-events:none;
// //           opacity:0; transition:opacity .4s var(--ease);
// //           background:radial-gradient(220px 220px at var(--mx,50%) var(--my,50%), rgba(255,255,255,.35), transparent 60%);
// //         }
// //         .offer-card:hover .offer-card__sheen{ opacity:1; }
// //         .offer-card::after{
// //           content:""; position:absolute; inset:0; border-radius:20px; padding:1px;
// //           background:linear-gradient(135deg, rgba(255,255,255,.95), rgba(155,31,108,.4) 42%, transparent 72%);
// //           -webkit-mask:linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0);
// //           -webkit-mask-composite:xor; mask-composite:exclude;
// //           opacity:0; transition:opacity .5s var(--ease); pointer-events:none;
// //         }
// //         .offer-card:hover{
// //           background:linear-gradient(135deg, rgba(255,255,255,.3), rgba(255,255,255,.1));
// //           border-color:rgba(255,255,255,.85);
// //           box-shadow:
// //             0 1px 1px rgba(255,255,255,.6) inset,
// //             0 30px 60px rgba(155,31,108,.2);
// //         }
// //         .offer-card:hover::after{ opacity:1; }
// //         .offer-card:focus-visible{ outline:2px solid var(--magenta); outline-offset:3px; }

// //         .offer-card__orb{
// //           position:absolute; z-index:-1;
// //           right:6%; top:30%; transform:translateY(-50%);
// //           width:170px; height:170px; border-radius:50%;
// //           filter:blur(40px); opacity:.55;
// //           transition:opacity .5s var(--ease), transform .5s var(--ease);
// //         }
// //         .offer-card__orb--2{
// //           left:8%; right:auto; top:88%;
// //           width:120px; height:120px; filter:blur(40px); opacity:.35;
// //         }
// //         .offer-card:hover .offer-card__orb{ opacity:.8; transform:translateY(-50%) scale(1.1); }

// //         .offer-card__plate{
// //           position:relative; z-index:2;
// //           width:100%; height:172px;
// //           border-radius:14px;
// //           display:grid; place-items:center;
// //           padding:16px;
// //           background:linear-gradient(150deg, rgba(255,255,255,.55), rgba(255,255,255,.22));
// //           border:1px solid rgba(255,255,255,.6);
// //           box-shadow:0 1px 1px rgba(255,255,255,.5) inset, 0 10px 26px rgba(84,39,87,.10);
// //           transition:transform .5s var(--ease), box-shadow .5s var(--ease);
// //         }
// //         .offer-card:hover .offer-card__plate{ transform:scale(1.03); box-shadow:0 18px 36px rgba(84,39,87,.18); }
// //         .offer-card__plate img{
// //           max-width:100%; max-height:100%;
// //           width:auto; height:auto;
// //           object-fit:contain;
// //           filter:drop-shadow(0 8px 16px rgba(84,39,87,.16));
// //           transition:transform .5s var(--ease);
// //         }
// //         .offer-card:hover .offer-card__plate img{ transform:scale(1.06); }

// //         .offer-card__body{ position:relative; z-index:2; }
// //         .offer-card__head{ display:flex; align-items:center; gap:10px; margin-bottom:10px; }
// //         .offer-card__icon{
// //           display:grid; place-items:center; width:30px; height:30px; flex:none;
// //           border-radius:50%;
// //           background:rgba(255,255,255,.45); color:var(--magenta);
// //           transition:background .4s var(--ease), color .4s var(--ease);
// //         }
// //         .offer-card:hover .offer-card__icon{ background:var(--magenta); color:#fff; }
// //         .offer-card__title{ margin:0; font-size:17px; font-weight:800; line-height:1.22; letter-spacing:-.01em; color:var(--ink); }
// //         .offer-card__text{
// //           margin:0 0 14px; font-size:13px; line-height:1.5; color:var(--muted);
// //           display:-webkit-box; -webkit-line-clamp:2; -webkit-box-orient:vertical; overflow:hidden;
// //         }
// //         .offer-card__cta{
// //           display:inline-flex; align-items:center; gap:8px;
// //           font-size:11px; font-weight:800; letter-spacing:.16em; text-transform:uppercase; color:var(--magenta);
// //         }
// //         .offer-card__cta i{ font-style:normal; transition:transform .4s var(--ease); }
// //         .offer-card:hover .offer-card__cta i{ transform:translateX(5px); }

// //         .hlc-offer__empty{ padding:40px 0; font-size:15px; color:var(--muted); }

// //         /* ---------- responsive ---------- */
// //         @media (max-width:1040px){ .hlc-offer__row{ grid-template-columns:repeat(2,minmax(0,1fr)); } }
// //         @media (max-width:600px){
// //           .hlc-offer__row{ grid-template-columns:1fr; }
// //           .offer-card{ padding:20px; }
// //           .offer-card__plate{ height:150px; }
// //           .offer-card__orb{ width:130px; height:130px; }
// //           .offer-card:hover{ transform:translateY(-6px); }
// //         }
// //         @media (prefers-reduced-motion:reduce){
// //           .offer-card, .offer-card__plate, .offer-card__plate img, .offer-card__icon, .offer-card__cta i, .offer-card__orb, .offer-card__sheen{ transition:none; }
// //           .offer-card{ transform:none !important; }
// //           .offer-card:hover .offer-card__plate{ transform:none; }
// //           .offer-card:hover .offer-card__plate img{ transform:none; }
// //         }
// //       `}</style>

// //       <section id="offer" className="hlc-offer" aria-labelledby="offer-title">
// //         <span className="hlc-offer__pane hlc-offer__pane--1" aria-hidden="true" />
// //         <span className="hlc-offer__pane hlc-offer__pane--2" aria-hidden="true" />
// //         <div className="hlc-offer__inner">
// //           <header className="hlc-offer__head">
// //             <p className="hlc-offer__brand">HLC</p>
// //             <h2 id="offer-title" className="hlc-offer__title">
// //               Every space needs a different light.
// //             </h2>
// //             <p className="hlc-offer__sub">
// //               Six product families covering homes, offices, retail floors and
// //               outdoor sites. Pick a family to see the full range.
// //             </p>
// //           </header>

// //           {CATEGORIES.length === 0 ? (
// //             <p className="hlc-offer__empty">No categories available right now.</p>
// //           ) : (
// //             <div className="hlc-offer__row">
// //               {CATEGORIES.map((category, i) => (
// //                 <motion.button
// //                   key={category.id}
// //                   type="button"
// //                   className="offer-card"
// //                   onClick={() => handleNavigate(category)}
// //                   onMouseMove={handleTilt}
// //                   onMouseLeave={resetTilt}
// //                   aria-label={`Explore ${category.title}`}
// //                   custom={i}
// //                   variants={cardMotion}
// //                   initial="hidden"
// //                   whileInView="show"
// //                   viewport={{ once: true, amount: 0.2 }}
// //                 >
// //                   <span className="offer-card__orb" style={{ background: ORB[i % ORB.length] }} />
// //                   <span className="offer-card__orb offer-card__orb--2" style={{ background: ORB[(i + 3) % ORB.length] }} />
// //                   <span className="offer-card__sheen" aria-hidden="true" />

// //                   <span className="offer-card__plate">
// //                     {category.image && (
// //                       <img src={category.image} alt={category.title} loading="lazy" decoding="async" />
// //                     )}
// //                   </span>

// //                   <span className="offer-card__body">
// //                     <span className="offer-card__head">
// //                       <span className="offer-card__icon"><Icon name={category.icon} /></span>
// //                       <h3 className="offer-card__title">{category.title}</h3>
// //                     </span>
// //                     <p className="offer-card__text">{category.description}</p>
// //                     <span className="offer-card__cta">Explore <i aria-hidden="true">→</i></span>
// //                   </span>
// //                 </motion.button>
// //               ))}
// //             </div>
// //           )}
// //         </div>
// //       </section>
// //     </>
// //   );
// // };

// // export default OfferSection;


// import React, { useRef } from "react";
// import { useNavigate } from "react-router-dom";
// import { motion } from "framer-motion";
// import LedBulbImg from "../assets/products/bulb.png";
// import DownlightImg from "../assets/products/downlights.png";
// import PanelImg from "../assets/products/panels.png";
// import FloodImg from "../assets/products/flood-street.png";
// import RopeImg from "../assets/products/rope-light.png";
// import BattenImg from "../assets/products/batten.png";

// /* ---------- small line icons, one per family ---------- */
// const Icon = ({ name }) => {
//   const common = {
//     width: 18,
//     height: 18,
//     viewBox: "0 0 24 24",
//     fill: "none",
//     stroke: "currentColor",
//     strokeWidth: 1.8,
//     strokeLinecap: "round",
//     strokeLinejoin: "round",
//     "aria-hidden": "true",
//   };
//   switch (name) {
//     case "bulb":
//       return (<svg {...common}><path d="M9 18h6M10 21h4M12 3a6 6 0 0 0-3.5 10.9c.5.4.8 1 .8 1.6V16h5.4v-.5c0-.6.3-1.2.8-1.6A6 6 0 0 0 12 3Z" /></svg>);
//     case "downlight":
//       return (<svg {...common}><circle cx="12" cy="9" r="5" /><path d="M6 20h12M8.5 16.5 7 20M15.5 16.5 17 20" /></svg>);
//     case "tube":
//       return (<svg {...common}><rect x="3" y="9" width="18" height="6" rx="3" /><path d="M7 12h10" /></svg>);
//     case "panel":
//       return (<svg {...common}><rect x="4" y="4" width="16" height="16" rx="2" /><path d="M9 9h6v6H9z" /></svg>);
//     case "flood":
//       return (<svg {...common}><rect x="4" y="5" width="12" height="9" rx="1.5" /><path d="M16 8.5h4M10 14v5M7 19h6" /></svg>);
//     default:
//       return (<svg {...common}><circle cx="7" cy="9" r="2" /><circle cx="14" cy="15" r="2" /><circle cx="18" cy="7" r="2" /></svg>);
//   }
// };

// /* ================= STATIC LOCAL CATEGORIES =================
//    `dbCategory` must match the real `products.category` value in MySQL exactly. */
// const CATEGORIES = [
//   { id: "led-bulbs", title: "LED Bulb Series", dbCategory: "LED BULB SERIES", description: "Reliable, efficient bulbs for every home and office.", image: LedBulbImg, icon: "bulb", subcategories: [] },
//   { id: "downlights", title: "Downlights & COB", dbCategory: "DOWNLIGHT SERIES", description: "Sleek COB and SMD downlights for modern interiors.", image: DownlightImg, icon: "downlight", subcategories: [] },
//   { id: "batten-tube", title: "Batten & Tube Series", dbCategory: "BATTEN AND LED TUBE SERIES", description: "Durable, bright tube lights and battens for all spaces.", image: BattenImg, icon: "tube", subcategories: [] },
//   { id: "panel-lights", title: "Panel & Ceiling Lights", dbCategory: "PANEL LIGHT SERIES", description: "Modern panels for a clean, even ceiling finish.", image: PanelImg, icon: "panel", subcategories: [] },
//   { id: "flood-outdoor", title: "Flood & Outdoor", dbCategory: "STREET AND FLOOD LIGHT SERIES", description: "High-output flood and street lighting built for weather.", image: FloodImg, icon: "flood", subcategories: [] },
//   { id: "rope-decorative", title: "Rope & Decorative", dbCategory: "ROPE LIGHT SERIES", description: "Rope and strip lighting for accent and ambience.", image: RopeImg, icon: "rope", subcategories: [] },
// ];

// const cardMotion = {
//   hidden: { opacity: 0, y: 18 },
//   show: (i) => ({ opacity: 1, y: 0, transition: { duration: 0.55, delay: i * 0.06, ease: [0.16, 1, 0.3, 1] } }),
// };

// /* glow-orb tint per card, cycling the reference's pink→lilac→blue palette */
// const ORB = ["#f4a9c4", "#e6a9d6", "#c9b3e8", "#f0aecb", "#d3b0e6", "#b9c2ec"];

// const OfferSection = () => {
//   const navigate = useNavigate();
//   const handleNavigate = (category) => {
//     navigate("/product-by-categories", {
//       state: { category: category.dbCategory, subcategories: category.subcategories || [] },
//     });
//   };

//   /* ---- dynamic cursor-following 3D tilt ----
//      tilts each card toward the pointer; resets smoothly on leave.
//      Respects reduced-motion and skips on touch (no hover). */
//   const reduced = typeof window !== "undefined"
//     && window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

//   const handleTilt = (e) => {
//     if (reduced) return;
//     const card = e.currentTarget;
//     const b = card.getBoundingClientRect();
//     const px = (e.clientX - b.left) / b.width - 0.5;   // -0.5 .. 0.5
//     const py = (e.clientY - b.top) / b.height - 0.5;
//     const MAX = 10; // degrees
//     const rotY = px * MAX * 2;
//     const rotX = -py * MAX * 2;
//     card.style.transform =
//       `perspective(900px) rotateX(${rotX.toFixed(2)}deg) rotateY(${rotY.toFixed(2)}deg) translateY(-8px) translateZ(24px)`;
//     // move the glow toward the cursor for extra depth
//     card.style.setProperty("--mx", `${(px + 0.5) * 100}%`);
//     card.style.setProperty("--my", `${(py + 0.5) * 100}%`);
//   };
//   const resetTilt = (e) => {
//     const card = e.currentTarget;
//     card.style.transform = "";
//   };

//   return (
//     <>
//       <style>{`
//         #offer.hlc-offer{
//           --magenta:#9b1f6c;
//           --plum:#542757;
//           --ink:#191825;
//           --muted:#6b6880;
//           --ease:cubic-bezier(.16,1,.3,1);
//           position:relative;
//           width:100%;
//           padding:clamp(56px,7.5vw,100px) 0 clamp(64px,8vw,110px);
//           background:
//             radial-gradient(120% 120% at 6% 0%, rgba(244,196,206,.9) 0%, transparent 46%),
//             radial-gradient(120% 120% at 100% 2%, rgba(224,186,224,.85) 0%, transparent 48%),
//             radial-gradient(130% 120% at 0% 100%, rgba(206,196,232,.8) 0%, transparent 50%),
//             radial-gradient(130% 120% at 100% 100%, rgba(196,206,232,.75) 0%, transparent 52%),
//             linear-gradient(160deg,#f2ecf6 0%,#f8f4fb 50%,#f1edf9 100%);
//           font-family:"Manrope","Inter",system-ui,-apple-system,Segoe UI,Roboto,Arial,sans-serif;
//           color:var(--ink);
//           overflow:hidden;
//           isolation:isolate;
//         }

//         .hlc-offer__pane{
//           position:absolute; z-index:0; pointer-events:none;
//           border-radius:18px;
//           background:linear-gradient(135deg, rgba(255,255,255,.55), rgba(255,255,255,.12));
//           border:1px solid rgba(255,255,255,.65);
//           box-shadow:0 30px 60px rgba(84,39,87,.14), 0 1px 1px rgba(255,255,255,.6) inset;
//           -webkit-backdrop-filter:blur(4px); backdrop-filter:blur(4px);
//         }
//         .hlc-offer__pane--1{ width:260px; height:150px; top:-2%; right:20%; transform:rotate(-9deg); opacity:.8; }
//         .hlc-offer__pane--2{ width:300px; height:170px; top:4%; right:-4%; transform:rotate(-6deg); opacity:.7; }
//         @media (max-width:900px){ .hlc-offer__pane{ display:none; } }

//         .hlc-offer__inner{
//           position:relative; z-index:2;
//           width:min(1180px,92vw); margin:0 auto;
//         }

//         .hlc-offer__head{ max-width:560px; margin:0 0 clamp(34px,4vw,50px); }
//         .hlc-offer__brand{ margin:0 0 12px; font-size:13px; font-weight:800; letter-spacing:.06em; color:var(--ink); text-transform:uppercase; }
//         .hlc-offer__title{
//           margin:0 0 14px;
//           font-family:"Sora","Manrope",sans-serif;
//           font-size:clamp(30px,4.4vw,50px);
//           font-weight:800; line-height:1.1; letter-spacing:-.03em; color:var(--ink);
//         }
//         .hlc-offer__sub{ margin:0; max-width:440px; font-size:15px; line-height:1.6; color:var(--muted); }

//         .hlc-offer__row{
//           display:grid; grid-template-columns:repeat(3,minmax(0,1fr));
//           gap:clamp(20px,2.2vw,30px);
//           perspective:1200px;
//         }

//         /* ---------- glass card ---------- */
//         .offer-card{
//           -webkit-appearance:none; appearance:none; margin:0;
//           font:inherit; color:inherit; text-align:left; cursor:pointer;
//           position:relative; isolation:isolate;
//           display:flex; flex-direction:column; gap:18px;
//           padding:24px 24px 22px;
//           border-radius:20px;
//           background:linear-gradient(135deg, rgba(255,255,255,.2), rgba(255,255,255,.06));
//           border:1px solid rgba(255,255,255,.55);
//           box-shadow:
//             0 1px 1px rgba(255,255,255,.5) inset,
//             0 16px 40px rgba(84,39,87,.08);
//           -webkit-backdrop-filter:blur(10px) saturate(1.3);
//           backdrop-filter:blur(10px) saturate(1.3);
//           overflow:hidden;
//           transform-style:preserve-3d;
//           /* fast transform so the tilt tracks the cursor; slower reset via leave */
//           transition:transform .18s ease-out, box-shadow .5s var(--ease), background .5s var(--ease), border-color .5s var(--ease);
//         }
//         /* cursor-following sheen highlight */
//         .offer-card__sheen{
//           position:absolute; inset:0; z-index:1; border-radius:20px; pointer-events:none;
//           opacity:0; transition:opacity .4s var(--ease);
//           background:radial-gradient(220px 220px at var(--mx,50%) var(--my,50%), rgba(255,255,255,.35), transparent 60%);
//         }
//         .offer-card:hover .offer-card__sheen{ opacity:1; }
//         .offer-card::after{
//           content:""; position:absolute; inset:0; border-radius:20px; padding:1px;
//           background:linear-gradient(135deg, rgba(255,255,255,.95), rgba(155,31,108,.4) 42%, transparent 72%);
//           -webkit-mask:linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0);
//           -webkit-mask-composite:xor; mask-composite:exclude;
//           opacity:0; transition:opacity .5s var(--ease); pointer-events:none;
//         }
//         .offer-card:hover{
//           background:linear-gradient(135deg, rgba(255,255,255,.3), rgba(255,255,255,.1));
//           border-color:rgba(255,255,255,.85);
//           box-shadow:
//             0 1px 1px rgba(255,255,255,.6) inset,
//             0 30px 60px rgba(155,31,108,.2);
//         }
//         .offer-card:hover::after{ opacity:1; }
//         .offer-card:focus-visible{ outline:2px solid var(--magenta); outline-offset:3px; }

//         .offer-card__orb{
//           position:absolute; z-index:-1;
//           right:6%; top:30%; transform:translateY(-50%);
//           width:170px; height:170px; border-radius:50%;
//           filter:blur(40px); opacity:.55;
//           transition:opacity .5s var(--ease), transform .5s var(--ease);
//         }
//         .offer-card__orb--2{
//           left:8%; right:auto; top:88%;
//           width:120px; height:120px; filter:blur(40px); opacity:.35;
//         }
//         .offer-card:hover .offer-card__orb{ opacity:.8; transform:translateY(-50%) scale(1.1); }

//         .offer-card__plate{
//           position:relative; z-index:2;
//           width:100%; height:180px;
//           border-radius:14px;
//           display:flex; align-items:center; justify-content:center;
//           padding:18px;
//           background:linear-gradient(150deg, rgba(255,255,255,.6), rgba(255,255,255,.28));
//           border:1px solid rgba(255,255,255,.65);
//           box-shadow:0 1px 1px rgba(255,255,255,.5) inset, 0 10px 26px rgba(84,39,87,.10);
//           overflow:hidden;
//           transition:box-shadow .5s var(--ease);
//         }
//         .offer-card:hover .offer-card__plate{ box-shadow:0 16px 34px rgba(84,39,87,.16); }
//         .offer-card__plate img{
//           display:block;
//           max-width:100%; max-height:100%;
//           width:auto; height:auto;
//           object-fit:contain;
//           filter:drop-shadow(0 6px 14px rgba(84,39,87,.14));
//           transition:transform .5s var(--ease);
//         }
//         .offer-card:hover .offer-card__plate img{ transform:scale(1.05); }

//         .offer-card__body{ position:relative; z-index:2; }
//         .offer-card__head{ display:flex; align-items:center; gap:10px; margin-bottom:10px; }
//         .offer-card__icon{
//           display:grid; place-items:center; width:30px; height:30px; flex:none;
//           border-radius:50%;
//           background:rgba(255,255,255,.45); color:var(--magenta);
//           transition:background .4s var(--ease), color .4s var(--ease);
//         }
//         .offer-card:hover .offer-card__icon{ background:var(--magenta); color:#fff; }
//         .offer-card__title{ margin:0; font-size:17px; font-weight:800; line-height:1.22; letter-spacing:-.01em; color:var(--ink); }
//         .offer-card__text{
//           margin:0 0 14px; font-size:13px; line-height:1.5; color:var(--muted);
//           display:-webkit-box; -webkit-line-clamp:2; -webkit-box-orient:vertical; overflow:hidden;
//         }
//         .offer-card__cta{
//           display:inline-flex; align-items:center; gap:8px;
//           font-size:11px; font-weight:800; letter-spacing:.16em; text-transform:uppercase; color:var(--magenta);
//         }
//         .offer-card__cta i{ font-style:normal; transition:transform .4s var(--ease); }
//         .offer-card:hover .offer-card__cta i{ transform:translateX(5px); }

//         .hlc-offer__empty{ padding:40px 0; font-size:15px; color:var(--muted); }

//         /* ---------- responsive ---------- */
//         @media (max-width:1040px){ .hlc-offer__row{ grid-template-columns:repeat(2,minmax(0,1fr)); } }
//         @media (max-width:600px){
//           .hlc-offer__row{ grid-template-columns:1fr; }
//           .offer-card{ padding:20px; }
//           .offer-card__plate{ height:150px; }
//           .offer-card__orb{ width:130px; height:130px; }
//           .offer-card:hover{ transform:translateY(-6px); }
//         }
//         @media (prefers-reduced-motion:reduce){
//           .offer-card, .offer-card__plate, .offer-card__plate img, .offer-card__icon, .offer-card__cta i, .offer-card__orb, .offer-card__sheen{ transition:none; }
//           .offer-card{ transform:none !important; }
//           .offer-card:hover .offer-card__plate{ transform:none; }
//           .offer-card:hover .offer-card__plate img{ transform:none; }
//         }
//       `}</style>

//       <section id="offer" className="hlc-offer" aria-labelledby="offer-title">
//         <span className="hlc-offer__pane hlc-offer__pane--1" aria-hidden="true" />
//         <span className="hlc-offer__pane hlc-offer__pane--2" aria-hidden="true" />
//         <div className="hlc-offer__inner">
//           <header className="hlc-offer__head">
//             <p className="hlc-offer__brand">HLC</p>
//             <h2 id="offer-title" className="hlc-offer__title">
//               Every space needs a different light.
//             </h2>
//             <p className="hlc-offer__sub">
//               Six product families covering homes, offices, retail floors and
//               outdoor sites. Pick a family to see the full range.
//             </p>
//           </header>

//           {CATEGORIES.length === 0 ? (
//             <p className="hlc-offer__empty">No categories available right now.</p>
//           ) : (
//             <div className="hlc-offer__row">
//               {CATEGORIES.map((category, i) => (
//                 <motion.button
//                   key={category.id}
//                   type="button"
//                   className="offer-card"
//                   onClick={() => handleNavigate(category)}
//                   onMouseMove={handleTilt}
//                   onMouseLeave={resetTilt}
//                   aria-label={`Explore ${category.title}`}
//                   custom={i}
//                   variants={cardMotion}
//                   initial="hidden"
//                   whileInView="show"
//                   viewport={{ once: true, amount: 0.2 }}
//                 >
//                   <span className="offer-card__orb" style={{ background: ORB[i % ORB.length] }} />
//                   <span className="offer-card__orb offer-card__orb--2" style={{ background: ORB[(i + 3) % ORB.length] }} />
//                   <span className="offer-card__sheen" aria-hidden="true" />

//                   <span className="offer-card__plate">
//                     {category.image && (
//                       <img src={category.image} alt={category.title} loading="lazy" decoding="async" />
//                     )}
//                   </span>

//                   <span className="offer-card__body">
//                     <span className="offer-card__head">
//                       <span className="offer-card__icon"><Icon name={category.icon} /></span>
//                       <h3 className="offer-card__title">{category.title}</h3>
//                     </span>
//                     <p className="offer-card__text">{category.description}</p>
//                     <span className="offer-card__cta">Explore <i aria-hidden="true">→</i></span>
//                   </span>
//                 </motion.button>
//               ))}
//             </div>
//           )}
//         </div>
//       </section>
//     </>
//   );
// };

// export default OfferSection;


import React, { useRef, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { API_BASE_URL } from "../config/apiConfig";
import { getRealImageUrl } from "../utils/getProductImage";
import LedBulbImg from "../assets/products/bulb.png";
import DownlightImg from "../assets/products/downlights.png";
import PanelImg from "../assets/products/panels.png";
import FloodImg from "../assets/products/flood-street.png";
import RopeImg from "../assets/products/rope-light.png";
import BattenImg from "../assets/products/batten.png";

/* ---------- small line icons, one per family ---------- */
const Icon = ({ name }) => {
  const common = {
    width: 18,
    height: 18,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "aria-hidden": "true",
  };
  switch (name) {
    case "bulb":
      return (<svg {...common}><path d="M9 18h6M10 21h4M12 3a6 6 0 0 0-3.5 10.9c.5.4.8 1 .8 1.6V16h5.4v-.5c0-.6.3-1.2.8-1.6A6 6 0 0 0 12 3Z" /></svg>);
    case "downlight":
      return (<svg {...common}><circle cx="12" cy="9" r="5" /><path d="M6 20h12M8.5 16.5 7 20M15.5 16.5 17 20" /></svg>);
    case "tube":
      return (<svg {...common}><rect x="3" y="9" width="18" height="6" rx="3" /><path d="M7 12h10" /></svg>);
    case "panel":
      return (<svg {...common}><rect x="4" y="4" width="16" height="16" rx="2" /><path d="M9 9h6v6H9z" /></svg>);
    case "flood":
      return (<svg {...common}><rect x="4" y="5" width="12" height="9" rx="1.5" /><path d="M16 8.5h4M10 14v5M7 19h6" /></svg>);
    default:
      return (<svg {...common}><circle cx="7" cy="9" r="2" /><circle cx="14" cy="15" r="2" /><circle cx="18" cy="7" r="2" /></svg>);
  }
};

/* ================= DYNAMIC CATEGORIES =================
   Was a hardcoded array of exactly 6 categories — replaced with a live
   fetch (below, in OfferSection) so categories added/renamed/removed in
   the Admin Panel appear here automatically, same as everywhere else in
   the app.

   FALLBACK_IMAGE_MAP / resolveIcon are presentation-only: they pick one
   of the existing large photos / a line icon for the known HLC families
   when a category doesn't have its own uploaded image yet (true for all
   of them today, since category.image is currently empty for the real
   catalog) — the moment a real image is uploaded via Admin Panel it's
   used instead (see getRealImageUrl in the render below), no code
   change needed. Unrecognised/new categories (e.g. one that doesn't
   match any keyword) simply render without a fallback photo/plate
   rather than showing a wrong one. */
const FALLBACK_IMAGE_MAP = [
  { keywords: ["bulb", "candle"], image: LedBulbImg },
  { keywords: ["downlight", "down light", "cob", "smd", "ice light"], image: DownlightImg },
  { keywords: ["batten", "tube"], image: BattenImg },
  { keywords: ["panel"], image: PanelImg },
  { keywords: ["flood", "street"], image: FloodImg },
  { keywords: ["rope", "strip", "decorative"], image: RopeImg },
];
const ICON_KEYWORD_MAP = [
  { keywords: ["bulb", "candle"], icon: "bulb" },
  { keywords: ["downlight", "down light", "cob", "smd", "ice light"], icon: "downlight" },
  { keywords: ["batten", "tube"], icon: "tube" },
  { keywords: ["panel"], icon: "panel" },
  { keywords: ["flood", "street"], icon: "flood" },
];

function resolveFallbackImage(title) {
  const t = (title || "").toLowerCase();
  const match = FALLBACK_IMAGE_MAP.find(({ keywords }) => keywords.some((k) => t.includes(k)));
  return match ? match.image : null;
}
function resolveIcon(title) {
  const t = (title || "").toLowerCase();
  const match = ICON_KEYWORD_MAP.find(({ keywords }) => keywords.some((k) => t.includes(k)));
  return match ? match.icon : "default";
}

const cardMotion = {
  hidden: { opacity: 0, y: 18 },
  show: (i) => ({ opacity: 1, y: 0, transition: { duration: 0.55, delay: i * 0.06, ease: [0.16, 1, 0.3, 1] } }),
};

/* glow-orb tint per card, cycling the reference's pink→lilac→blue palette */
const ORB = ["#f4a9c4", "#e6a9d6", "#c9b3e8", "#f0aecb", "#d3b0e6", "#b9c2ec"];

const OfferSection = () => {
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);

  /* ================= FETCH CATEGORIES FROM adminhlc-api (MySQL) —
     same endpoint/parsing already used by MainCategory.js, so this
     section and the Categories page always agree on what exists. ================= */
  useEffect(() => {
    let cancelled = false;
    fetch(`${API_BASE_URL}/api/public/categories/list.php`)
      .then((res) => res.json())
      .then((data) => {
        if (cancelled) return;
        const parsed = Array.isArray(data)
          ? data.map((cat) => ({
              ...cat,
              subcategories: cat.subcategories
                ? Object.keys(cat.subcategories).map((sid) => cat.subcategories[sid])
                : [],
            }))
          : [];
        setCategories(parsed);
      })
      .catch((err) => {
        console.error("Failed to fetch categories:", err);
        if (!cancelled) setCategories([]);
      });
    return () => { cancelled = true; };
  }, []);

  const handleNavigate = (category) => {
    navigate("/product-by-categories", {
      state: { category: category.title, subcategories: category.subcategories || [] },
    });
  };

  /* ---- dynamic cursor-following 3D tilt ----
     tilts each card toward the pointer; resets smoothly on leave.
     Respects reduced-motion and skips on touch (no hover). */
  const reduced = typeof window !== "undefined"
    && window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  const handleTilt = (e) => {
    if (reduced) return;
    const card = e.currentTarget;
    const b = card.getBoundingClientRect();
    const px = (e.clientX - b.left) / b.width - 0.5;   // -0.5 .. 0.5
    const py = (e.clientY - b.top) / b.height - 0.5;
    const MAX = 10; // degrees
    const rotY = px * MAX * 2;
    const rotX = -py * MAX * 2;
    card.style.transform =
      `perspective(900px) rotateX(${rotX.toFixed(2)}deg) rotateY(${rotY.toFixed(2)}deg) translateY(-8px) translateZ(24px)`;
    // move the glow toward the cursor for extra depth
    card.style.setProperty("--mx", `${(px + 0.5) * 100}%`);
    card.style.setProperty("--my", `${(py + 0.5) * 100}%`);
  };
  const resetTilt = (e) => {
    const card = e.currentTarget;
    card.style.transform = "";
  };

  return (
    <>
      <style>{`
        #offer.hlc-offer{
          --magenta:#9b1f6c;
          --plum:#542757;
          --ink:#191825;
          --muted:#6b6880;
          --ease:cubic-bezier(.16,1,.3,1);
          position:relative;
          width:100%;
          padding:clamp(40px,5vw,64px) 0 clamp(44px,5vw,68px);
          background:
            radial-gradient(120% 120% at 6% 0%, rgba(244,196,206,.9) 0%, transparent 46%),
            radial-gradient(120% 120% at 100% 2%, rgba(224,186,224,.85) 0%, transparent 48%),
            radial-gradient(130% 120% at 0% 100%, rgba(206,196,232,.8) 0%, transparent 50%),
            radial-gradient(130% 120% at 100% 100%, rgba(196,206,232,.75) 0%, transparent 52%),
            linear-gradient(160deg,#f2ecf6 0%,#f8f4fb 50%,#f1edf9 100%);
          font-family:"Manrope","Inter",system-ui,-apple-system,Segoe UI,Roboto,Arial,sans-serif;
          color:var(--ink);
          overflow:hidden;
          isolation:isolate;
        }

        .hlc-offer__pane{
          position:absolute; z-index:0; pointer-events:none;
          border-radius:18px;
          background:linear-gradient(135deg, rgba(255,255,255,.55), rgba(255,255,255,.12));
          border:1px solid rgba(255,255,255,.65);
          box-shadow:0 30px 60px rgba(84,39,87,.14), 0 1px 1px rgba(255,255,255,.6) inset;
          -webkit-backdrop-filter:blur(4px); backdrop-filter:blur(4px);
        }
        .hlc-offer__pane--1{ width:260px; height:150px; top:-2%; right:20%; transform:rotate(-9deg); opacity:.8; }
        .hlc-offer__pane--2{ width:300px; height:170px; top:4%; right:-4%; transform:rotate(-6deg); opacity:.7; }
        @media (max-width:900px){ .hlc-offer__pane{ display:none; } }

        .hlc-offer__inner{
          position:relative; z-index:2;
          width:min(1180px,92vw); margin:0 auto;
        }

        .hlc-offer__head{ max-width:560px; margin:0 0 clamp(22px,2.6vw,32px); }
        .hlc-offer__brand{ margin:0 0 12px; font-size:13px; font-weight:800; letter-spacing:.06em; color:var(--ink); text-transform:uppercase; }
        .hlc-offer__title{
          margin:0 0 14px;
          font-family:"Sora","Manrope",sans-serif;
          font-size:clamp(30px,4.4vw,50px);
          font-weight:800; line-height:1.1; letter-spacing:-.03em; color:var(--ink);
        }
        .hlc-offer__sub{ margin:0; max-width:440px; font-size:15px; line-height:1.6; color:var(--muted); }

        .hlc-offer__row{
          display:grid; grid-template-columns:repeat(3,minmax(0,1fr));
          gap:clamp(16px,1.6vw,22px);
          perspective:1200px;
        }

        /* ---------- glass card ---------- */
        .offer-card{
          -webkit-appearance:none; appearance:none; margin:0;
          font:inherit; color:inherit; text-align:left; cursor:pointer;
          position:relative; isolation:isolate;
          display:flex; flex-direction:column; gap:14px;
          padding:18px 18px 18px;
          border-radius:20px;
          background:linear-gradient(135deg, rgba(255,255,255,.2), rgba(255,255,255,.06));
          border:1px solid rgba(255,255,255,.55);
          box-shadow:
            0 1px 1px rgba(255,255,255,.5) inset,
            0 16px 40px rgba(84,39,87,.08);
          -webkit-backdrop-filter:blur(10px) saturate(1.3);
          backdrop-filter:blur(10px) saturate(1.3);
          overflow:hidden;
          transform-style:preserve-3d;
          /* fast transform so the tilt tracks the cursor; slower reset via leave */
          transition:transform .18s ease-out, box-shadow .5s var(--ease), background .5s var(--ease), border-color .5s var(--ease);
        }
        /* cursor-following sheen highlight */
        .offer-card__sheen{
          position:absolute; inset:0; z-index:1; border-radius:20px; pointer-events:none;
          opacity:0; transition:opacity .4s var(--ease);
          background:radial-gradient(220px 220px at var(--mx,50%) var(--my,50%), rgba(255,255,255,.35), transparent 60%);
        }
        .offer-card:hover .offer-card__sheen{ opacity:1; }
        .offer-card::after{
          content:""; position:absolute; inset:0; border-radius:20px; padding:1px;
          background:linear-gradient(135deg, rgba(255,255,255,.95), rgba(155,31,108,.4) 42%, transparent 72%);
          -webkit-mask:linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0);
          -webkit-mask-composite:xor; mask-composite:exclude;
          opacity:0; transition:opacity .5s var(--ease); pointer-events:none;
        }
        .offer-card:hover{
          background:linear-gradient(135deg, rgba(255,255,255,.3), rgba(255,255,255,.1));
          border-color:rgba(255,255,255,.85);
          box-shadow:
            0 1px 1px rgba(255,255,255,.6) inset,
            0 30px 60px rgba(155,31,108,.2);
        }
        .offer-card:hover::after{ opacity:1; }
        .offer-card:focus-visible{ outline:2px solid var(--magenta); outline-offset:3px; }

        .offer-card__orb{
          position:absolute; z-index:-1;
          right:6%; top:30%; transform:translateY(-50%);
          width:170px; height:170px; border-radius:50%;
          filter:blur(40px); opacity:.55;
          transition:opacity .5s var(--ease), transform .5s var(--ease);
        }
        .offer-card__orb--2{
          left:8%; right:auto; top:88%;
          width:120px; height:120px; filter:blur(40px); opacity:.35;
        }
        .offer-card:hover .offer-card__orb{ opacity:.8; transform:translateY(-50%) scale(1.1); }

        .offer-card__plate{
          position:relative; z-index:2;
          width:100%; height:140px;
          border-radius:14px;
          display:flex; align-items:center; justify-content:center;
          padding:14px;
          background:linear-gradient(150deg, rgba(255,255,255,.6), rgba(255,255,255,.28));
          border:1px solid rgba(255,255,255,.65);
          box-shadow:0 1px 1px rgba(255,255,255,.5) inset, 0 10px 26px rgba(84,39,87,.10);
          overflow:hidden;
          transition:box-shadow .5s var(--ease);
        }
        .offer-card:hover .offer-card__plate{ box-shadow:0 16px 34px rgba(84,39,87,.16); }
        .offer-card__plate img{
          display:block;
          max-width:100%; max-height:100%;
          width:auto; height:auto;
          object-fit:contain;
          filter:drop-shadow(0 6px 14px rgba(84,39,87,.14));
          transition:transform .5s var(--ease);
        }
        .offer-card:hover .offer-card__plate img{ transform:scale(1.05); }

        .offer-card__body{ position:relative; z-index:2; }
        .offer-card__head{ display:flex; align-items:center; gap:10px; margin-bottom:8px; }
        .offer-card__icon{
          display:grid; place-items:center; width:30px; height:30px; flex:none;
          border-radius:50%;
          background:rgba(255,255,255,.45); color:var(--magenta);
          transition:background .4s var(--ease), color .4s var(--ease);
        }
        .offer-card:hover .offer-card__icon{ background:var(--magenta); color:#fff; }
        .offer-card__title{ margin:0; font-size:16px; font-weight:800; line-height:1.2; letter-spacing:-.01em; color:var(--ink); }
        .offer-card__text{
          margin:0 0 12px; font-size:12.5px; line-height:1.45; color:var(--muted);
          display:-webkit-box; -webkit-line-clamp:2; -webkit-box-orient:vertical; overflow:hidden;
        }
        .offer-card__cta{
          display:inline-flex; align-items:center; gap:8px;
          font-size:11px; font-weight:800; letter-spacing:.16em; text-transform:uppercase; color:var(--magenta);
        }
        .offer-card__cta i{ font-style:normal; transition:transform .4s var(--ease); }
        .offer-card:hover .offer-card__cta i{ transform:translateX(5px); }

        .hlc-offer__empty{ padding:40px 0; font-size:15px; color:var(--muted); }

        /* ---------- responsive ---------- */
        @media (max-width:1040px){ .hlc-offer__row{ grid-template-columns:repeat(2,minmax(0,1fr)); } }
        @media (max-width:600px){
          .hlc-offer__row{ grid-template-columns:1fr; }
          .offer-card{ padding:20px; }
          .offer-card__plate{ height:130px; }
          .offer-card__orb{ width:130px; height:130px; }
          .offer-card:hover{ transform:translateY(-6px); }
        }
        @media (prefers-reduced-motion:reduce){
          .offer-card, .offer-card__plate, .offer-card__plate img, .offer-card__icon, .offer-card__cta i, .offer-card__orb, .offer-card__sheen{ transition:none; }
          .offer-card{ transform:none !important; }
          .offer-card:hover .offer-card__plate{ transform:none; }
          .offer-card:hover .offer-card__plate img{ transform:none; }
        }
      `}</style>

      <section id="offer" className="hlc-offer" aria-labelledby="offer-title">
        <span className="hlc-offer__pane hlc-offer__pane--1" aria-hidden="true" />
        <span className="hlc-offer__pane hlc-offer__pane--2" aria-hidden="true" />
        <div className="hlc-offer__inner">
          <header className="hlc-offer__head">
            {/* <p className="hlc-offer__brand">HLC</p> */}
            <h2 id="offer-title" className="hlc-offer__title">
              Every space needs a different light.
            </h2>
            <p className="hlc-offer__sub">
              Six product families covering homes, offices, retail floors and
              outdoor sites. Pick a family to see the full range.
            </p>
          </header>

          {categories.length === 0 ? (
            <p className="hlc-offer__empty">No categories available right now.</p>
          ) : (
            <div className="hlc-offer__row">
              {categories.map((category, i) => {
                const plateImg = getRealImageUrl(category) || resolveFallbackImage(category.title);
                return (
                  <motion.button
                    key={category.id}
                    type="button"
                    className="offer-card"
                    onClick={() => handleNavigate(category)}
                    onMouseMove={handleTilt}
                    onMouseLeave={resetTilt}
                    aria-label={`Explore ${category.title}`}
                    custom={i}
                    variants={cardMotion}
                    initial="hidden"
                    whileInView="show"
                    viewport={{ once: true, amount: 0.2 }}
                  >
                    <span className="offer-card__orb" style={{ background: ORB[i % ORB.length] }} />
                    <span className="offer-card__orb offer-card__orb--2" style={{ background: ORB[(i + 3) % ORB.length] }} />
                    <span className="offer-card__sheen" aria-hidden="true" />

                    <span className="offer-card__plate">
                      {plateImg && (
                        <img src={plateImg} alt={category.title} loading="lazy" decoding="async" />
                      )}
                    </span>

                    <span className="offer-card__body">
                      <span className="offer-card__head">
                        <span className="offer-card__icon"><Icon name={resolveIcon(category.title)} /></span>
                        <h3 className="offer-card__title">{category.title}</h3>
                      </span>
                      <p className="offer-card__text">{category.description}</p>
                      <span className="offer-card__cta">Explore <i aria-hidden="true">→</i></span>
                    </span>
                  </motion.button>
                );
              })}
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default OfferSection;